// chat43 3-20-26 1:30pm
/* =========================================================
   Cutting Board Builder (Theme Prototype)
   - Runs inside a Shopify Custom Liquid section
   - Mount div: <div id="cutting-board-builder"></div>
   - Shopify sections can load after DOMContentLoaded, so we do NOT rely on it.
   ========================================================= */



/* =========================
   SECTION 1 — Builder Loader (loadBuilder)
   - Finds the mount element and prevents double-init.
   - Loads Liquid-injected JSON blobs (woods, variants, settings).
   - Builds the UI, binds handlers, and kicks off initial render.
   ========================= */
function loadBuilder() {



  /* =========================
     SECTION 1a — Mount + Boot Guard
     - Locates the mount div and aborts if missing.
     - Prevents double-initialization via dataset flag.
     - Keeps builder stable across Shopify section reloads.
     ========================= */
  const el = document.getElementById("cutting-board-builder");
  
  if (!el) { console.warn("CBB: mount #cutting-board-builder not found"); return; }

  // Prevent double-init
  if (el.dataset.cbbInitialized === "1") return;
  el.dataset.cbbInitialized = "1";
  //============ Section 1a End










  /* =========================
     SECTION 1b — Load woods JSON + variants JSON (from Liquid)
     - Reads script tags injected by Liquid and parses JSON safely.
     - WOODS_DATA: metaobject woods payload.
     - VARIANTS_DATA: strip product variants payload.
     ========================= */
  let WOODS_DATA = [];
  const woodsTag = document.getElementById("cbb-woods-json");
  if (woodsTag) {
    try {
      WOODS_DATA = JSON.parse(woodsTag.textContent || "[]");
    } catch (e) {
      console.error("Failed to parse cbb-woods-json", e);
    }
  }

  let VARIANTS_DATA = [];
  const variantsTag = document.getElementById("cbb-variants-json");
  if (variantsTag) {
    try {
      VARIANTS_DATA = JSON.parse(variantsTag.textContent || "[]");
    } catch (e) {
      console.error("Failed to parse cbb-variants-json", e);
    }
  }
  //============ Section 1b End










  /* =========================
     SECTION 1c — Load settings JSON (from Liquid)
     - Loads decimal-based settings (waste_pct, margin_pct, etc.).
     - Provides defaults so the builder never hard-crashes.
     - SETTINGS values are used by pricing logic elsewhere.
     ========================= */
  let SETTINGS = {
    waste_pct: 0, // decimal (0.30 = 30%)
    planer_removal_in: 0, // inches
    labor_per_cut: 0, // dollars per strip
    shipping_cost: 0, // dollars
    margin_pct: 0, // decimal (0.50 = 50% true margin)
  };

  const settingsTag = document.getElementById("cbb-settings-json");
  if (settingsTag) {
    try {
      const parsed = JSON.parse(settingsTag.textContent || "{}");
      SETTINGS = { ...SETTINGS, ...parsed };
    } catch (e) {
      console.error("Failed to parse cbb-settings-json", e);
    }
  }
  //============ Section 1c End










  /* =========================
     SECTION 2 — UI Shell HTML
     - Defines the color system used by the builder UI.
     - Injects the full UI markup into the mount element.
     - Wires Add-to-Cart immediately after the button exists.
     ========================= */

  // ===== COLOR SYSTEM =====
  const COLOR_MAIN = "#ffffff";                 // Main + Button Area
  const COLOR_BUTTON_AREA = COLOR_MAIN;         // same as main background

  const COLOR_STRIP_AREA = "#f3f3f3";           // Strip Area background
  const COLOR_PREVIEW_BG = "#ffffff";           // Board preview background

  const COLOR_BORDER_MAIN = "#a89f90";          // Main container border
  const COLOR_BORDER_STRIP = "#d2c9bb";         // Strip area border

  const COLOR_PRIMARY_BTN = "#1f3a5f";          // Add to Cart

  // Utility buttons (Mirror / Start Over)
  const COLOR_UTILITY_BTN_BG = "#e6e6e6";
  const COLOR_UTILITY_BTN_BORDER = "#c9c9c9";
  const COLOR_UTILITY_BTN_HOVER_BG = "#c7c7c7";

  // Text overlay + modal
  const COLOR_TEXT_BURN = "#6b4b2a";            // “laser burn” look
  const COLOR_MODAL_BACKDROP = "rgba(0,0,0,0.45)";
  const COLOR_MODAL_PANEL_BG = "#ffffff";
  const COLOR_MODAL_BORDER = "#d8d8d8";

  el.innerHTML = `
<div style="padding:16px;border:2px solid ${COLOR_BORDER_MAIN};border-radius:8px;background:${COLOR_MAIN};">

    <!-- TOP BAR -->
    <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:18px;flex-wrap:wrap;background:${COLOR_BUTTON_AREA};padding:12px;border-radius:6px;">

      <!-- LEFT -->
      <div style="display:flex;flex-direction:column;gap:10px;min-width:260px;flex:1;">

        <div>
          <label style="display:block;margin-bottom:6px;font-weight:700;">Board length</label>
          <select id="cb-length" style="padding:6px;width:90px;font-size:14px;">
            <option value="12">12"</option>
            <option value="16" selected>16"</option>
            <option value="20">20"</option>
          </select>
        </div>

        <!-- WIDTH -->
        <div style="display:flex;align-items:flex-end;gap:14px;">
          <div>
            <div style="font-weight:600;">
              Current width: <span id="cb-total-width">0</span>"
            </div>

            <div style="margin-top:6px;font-weight:700;">
              Maximum width 24"
            </div>

            <div id="cb-price-box"
              style="display:flex;flex-direction:column;align-items:flex-start;gap:2px;margin-top:14px;padding:10px 12px;border:1px solid ${COLOR_UTILITY_BTN_BORDER};border-radius:8px;background:#fafafa;min-width:125px;max-width:155px;">
              <div style="font-size:12px;color:#666;font-weight:700;">Your Board</div>
              <div id="cb-live-price" style="font-size:28px;line-height:1;font-weight:900;color:#111;">$0.00</div>
            </div>
          </div>
        </div>

      </div>

      <!-- RIGHT -->
      <div style="margin-left:auto;display:flex;flex-direction:column;align-items:flex-end;gap:10px;min-width:210px;">

        <button id="cb-add-to-cart" type="button"
          style="padding:10px 14px;border:1px solid ${COLOR_PRIMARY_BTN};border-radius:8px;background:${COLOR_PRIMARY_BTN};color:#fff;font-weight:800;margin-top:10px;">
          ADD TO CART
        </button>

        <button id="cb-mirror" type="button"
          style="padding:8px 12px;border:1px solid ${COLOR_UTILITY_BTN_BORDER};border-radius:8px;background:${COLOR_UTILITY_BTN_BG};font-weight:600;">
          Mirror Image
        </button>

        <button id="cb-start-over" type="button"
          style="padding:8px 12px;border:1px solid ${COLOR_UTILITY_BTN_BORDER};border-radius:8px;background:${COLOR_UTILITY_BTN_BG};font-weight:600;">
          Start Over
        </button>

        <button id="cb-print" type="button"
          style="padding:8px 12px;border:1px solid ${COLOR_UTILITY_BTN_BORDER};border-radius:8px;background:${COLOR_UTILITY_BTN_BG};font-weight:600;">
          Print My Design
        </button>
      </div>

    </div>

    <!-- STATUS -->
    <div id="cb-width-msg" style="
      margin-top:10px;
      font-size:13px;
      color:#555;
      text-align:center;
      width:100%;
    ">
      Select a wood species below to begin.
    </div>

    <!-- PREVIEW -->
    <div id="cb-preview"
         style="border:1px solid ${COLOR_PREVIEW_BG};border-radius:8px;background:${COLOR_PREVIEW_BG};padding:14px;margin-top:10px;">
    </div>

    <!-- STRIP AREA -->
    <div id="cb-strips"
         style="margin-top:12px;max-height:320px;height:auto;overflow-y:auto;overflow-x:auto;-webkit-overflow-scrolling:touch;border:1px solid ${COLOR_BORDER_STRIP};border-radius:8px;padding:8px;background:${COLOR_STRIP_AREA};">
    </div>

    <div id="cbb-admin-warn" style="display:none;margin-top:14px;padding:10px 12px;border:1px solid #f0c36d;background:#fff7d6;border-radius:8px;">
      <div style="font-weight:700;">Builder setup issue</div>
      <div style="margin-top:4px;font-size:13px;">
        No usable woods were loaded.
      </div>
    </div>

    <!-- TEXT MODAL ROOT (injected when needed) -->
    <div id="cbb-text-modal-root"></div>

  </div>
`;

  // Wire Add-to-Cart ONLY once, immediately after the button exists.
  cbbWireAddToCartButton();
  //============ Section 2 End










  /* =========================
     SECTION 2a — Button Hover Effects
     - Adds hover styling to utility buttons.
     - Keeps hover behavior centralized and reusable.
     - Called immediately after UI injection.
     ========================= */
  function cbbWireButtonHovers() {
    const buttons = [
      document.getElementById("cb-mirror"),
      document.getElementById("cb-start-over")
    ];

    buttons.forEach((btn) => {
      if (!btn) return;

      btn.addEventListener("mouseenter", () => {
        btn.style.background = COLOR_UTILITY_BTN_HOVER_BG;
      });

      btn.addEventListener("mouseleave", () => {
        btn.style.background = COLOR_UTILITY_BTN_BG;
      });
    });
  }

  cbbWireButtonHovers();
  //============ Section 2a End










  /* =========================
     SECTION 3 — Config (easy knobs)
     - Defines strip sizing increments and min/max constraints.
     - Sets total width limits and maximum strip count.
     - Includes any fixed IDs used by downstream logic.
     ========================= */
  const STRIP_INCREMENT = 0.5; // 0.25 = 1/4"
  const STRIP_MIN = 0.5;
  const STRIP_MAX = 4;

  const TOTAL_WIDTH_MIN = 6;
  const TOTAL_WIDTH_MAX = 24;

  const MAX_STRIPS = 21;
  const KIT_VARIANT_ID = 52109211697446;
  //============ Section 3 End










  /* =========================
     SECTION 4 — Woods (from Metaobjects JSON)
     - Filters woods to only Active entries with valid numeric pricing.
     - Defines accent wood rules and allowed widths.
     - Builds texture and PPBF lookup maps used in rendering and validation.
     ========================= */
  const ACTIVE_WOODS = (WOODS_DATA || [])
    .filter((w) => w && w.active === true)
    .filter((w) => w.ppbf !== null && w.ppbf !== "" && !Number.isNaN(Number(w.ppbf)));

  // Accent woods and their allowed widths
  const ACCENT_WOODS = new Set(["Purple Heart", "Padauk", "Goibao"]);
  const ACCENT_WIDTHS = [0.5, 1.0];

  // Allowed widths overall
  const ALLOWED_WIDTHS = [0.5, 0.75, 1.0, 1.5, 2.0, 3.0];

  // Preferred dropdown order (exact)
  const WOOD_ORDER = ["Cherry", "Maple", "Walnut", "Padauk", "Goibao", "Purple Heart"];
  const WOOD_ORDER_INDEX = new Map(WOOD_ORDER.map((name, idx) => [name, idx]));

  const WOODS = ACTIVE_WOODS
    .map((w) => w.name)
    .filter(Boolean)
    .slice()
    .sort((a, b) => {
      const ai = WOOD_ORDER_INDEX.has(a) ? WOOD_ORDER_INDEX.get(a) : 999;
      const bi = WOOD_ORDER_INDEX.has(b) ? WOOD_ORDER_INDEX.get(b) : 999;

      if (ai !== bi) return ai - bi;

      // If both are "not listed", fall back to alpha so it's stable
      return String(a).localeCompare(String(b));
    });

  const WOOD_TEXTURE_URLS = Object.fromEntries(
    ACTIVE_WOODS.map((w) => [w.name, w.texture || ""])
  );

  const WOOD_PPBF = Object.fromEntries(
    ACTIVE_WOODS.map((w) => [w.name, Number(w.ppbf)])
  );

  if (!WOODS.length) {
    const warn = document.getElementById("cbb-admin-warn");
    if (warn) warn.style.display = "block";
  }
  //============ Section 4 End










  /* =========================
     SECTION 5 — State
     - Holds all builder state: board length, strips, and text config.
     - lastStripText is the single source of truth for text persistence.
     - Exposes state for debugging and cart integration.
     ========================= */
  const lengthSel0 = document.getElementById("cb-length");

  const state = {
    boardLength: Number(lengthSel0?.value || 16),
    thickness: 0.75, // fixed for now (not shown)
    strips: [{ width: 1.0, wood: "" }], // one ready row

    // Accent hint: show ONLY once per page load (no localStorage)
    accentHintShown: false,

    // Text on last strip (persisted)
    lastStripText: {
      enabled: false,         // checkbox state (only charges if true)
      text: "",               // user-entered text
      align: "center",        // "left" | "center" | "right"
      fontKey: "arial",       // "arial" | "georgia" | "courier"
      lettersCount: 0,        // A-Z only
    },
  };

  // expose state for Section 14 + debugging
  el._cbbState = state;
  window.CBB_STATE = state; // optional debug handle
  //============ Section 5 End










  /* =========================
     SECTION 5a — Mirror state + helpers + Persistence
     - Maintains a mirror undo snapshot for "Undo Mirror".
     - Saves and restores builder state via localStorage.
     - Normalizes/preserves lastStripText (fontKey, fontFamily, height).
     ========================= */
  const mirrorState = {
    snapshotStrips: null, // array or null
  };

  const STORAGE_KEY = "cbb_builder_state_v1";

  function setMirrorButtonLabel() {
    const btn = document.getElementById("cb-mirror");
    if (!btn) return;
    btn.textContent = mirrorState.snapshotStrips ? "Undo Mirror" : "Mirror Image";
  }

  function clearMirrorUndo() {
    mirrorState.snapshotStrips = null;
    setMirrorButtonLabel();
  }

  function cloneStrips(strips) {
    return (strips || []).map((s) => ({
      width: Number(s.width),
      wood: String(s.wood || ""),
    }));
  }

  function cloneLastStripText(src) {
    const s = src || {};

    const enabled = Boolean(s.enabled);
    const text = String(s.text || "");

    const alignRaw = String(s.align || "center");
    const align =
      alignRaw === "left" || alignRaw === "right" ? alignRaw : "center";

    // ✅ allow dancing
    const fkRaw = String(s.fontKey || (String(s.fontFamily || "").includes("Dancing Script") ? "dancing" : "arial"));
    const fontKey =
      fkRaw === "georgia" || fkRaw === "dancing" ? fkRaw : "arial";

    const lettersCount = Number(s.lettersCount);
    const letterHeightIn = Number(s.letterHeightIn);

    // ✅ persist fontFamily (used by overlay rendering)
    const fontFamily = String(s.fontFamily || "");

    return {
      enabled,
      text,
      align,
      fontKey,
      fontFamily,
      lettersCount: Number.isFinite(lettersCount) ? lettersCount : 0,

      // persist chosen letter height
      letterHeightIn:
        Number.isFinite(letterHeightIn) && letterHeightIn > 0 ? letterHeightIn : 0.5,
    };
  }

  function saveState() {
    try {
      const payload = {
        boardLength: Number(state.boardLength),
        thickness: Number(state.thickness),
        strips: cloneStrips(state.strips),
        lastStripText: cloneLastStripText(state.lastStripText),
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      console.warn("Failed to save builder state", e);
    }
  }

  function loadState(opts) {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;

      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object") return false;

      const stripMin = Number(opts?.stripMin);
      const stripMax = Number(opts?.stripMax);
      const maxStrips = Number(opts?.maxStrips);

      if (!Number.isFinite(stripMin) || !Number.isFinite(stripMax) || !Number.isFinite(maxStrips)) {
        return false;
      }

      const bl = Number(parsed.boardLength);
      if (Number.isFinite(bl)) state.boardLength = bl;

      const th = Number(parsed.thickness);
      if (Number.isFinite(th)) state.thickness = th;

      if (Array.isArray(parsed.strips) && parsed.strips.length > 0) {
        const cleaned = parsed.strips
          .map((s) => {
            let w = Number(s?.width);
            if (!Number.isFinite(w)) w = stripMin;
            w = Math.max(stripMin, Math.min(stripMax, w));

            const wood = String(s?.wood || "");
            return { width: w, wood };
          })
          .slice(0, maxStrips);

        state.strips = cleaned.length ? cleaned : [{ width: 1.0, wood: "" }];
      }

      if (!Array.isArray(state.strips) || state.strips.length === 0) {
        state.strips = [{ width: 1.0, wood: "" }];
      }

      // restores letterHeight + fontKey + fontFamily
      state.lastStripText = cloneLastStripText(parsed.lastStripText);

      return true;
    } catch (e) {
      console.warn("Failed to load builder state", e);
      return false;
    }
  }
  //============ Section 5a End










  /* =========================
     SECTION 6 — Helpers
     - Formatting helpers for fractional inches.
     - Parsing/normalizing helpers for variant matching.
     - Variant lookup helpers for Wood / Length / Width option order.
     ========================= */
  function fmtQuarter(x) {
    const whole = Math.floor(x);
    const frac = Math.round((x - whole) * 4) / 4;
    if (frac === 0) return `${whole}`;
    if (frac === 0.25) return `${whole}-1/4`;
    if (frac === 0.5) return `${whole}-1/2`;
    if (frac === 0.75) return `${whole}-3/4`;
    return `${x}`;
  }

  function num(x, fallback = 0) {
    const n = Number(x);
    return Number.isFinite(n) ? n : fallback;
  }

  function buildStripWidthOptionsFromList(list, selected) {
    let html = "";
    const safe = Array.isArray(list) ? list : [];
    for (const v of safe) {
      const vv = Number(v);
      if (!Number.isFinite(vv)) continue;
      const sel = Math.abs(vv - selected) < 1e-9 ? "selected" : "";
      html += `<option value="${vv}" ${sel}>${fmtQuarter(vv)}"</option>`;
    }
    return html;
  }

  function normStr(s) {
    return String(s ?? "")
      .toLowerCase()
      .replaceAll('"', "")
      .replaceAll("″", "")
      .replaceAll("inches", "")
      .replaceAll("inch", "")
      .replaceAll("in", "")
      .replaceAll(" ", "")
      .trim();
  }

  function normNumString(s) {
    const t = normStr(s);
    const n = Number(t);
    return Number.isFinite(n) ? n : NaN;
  }

  // Variant option order chosen: Wood / Length / Width
  function findVariantIdByWoodLengthWidth(wood, lengthIn, widthIn) {
    const wNeed = String(wood || "").trim();
    const Lneed = Number(lengthIn);
    const Wneed = Number(widthIn);

    if (!wNeed) return null;
    if (!Number.isFinite(Lneed) || !Number.isFinite(Wneed)) return null;

    const wNeedNorm = normStr(wNeed);

    for (const v of VARIANTS_DATA || []) {
      const id = Number(v?.id);
      if (!Number.isFinite(id)) continue;

      const optWood = String(v?.option1 || "");
      const optLen = v?.option2;
      const optWid = v?.option3;

      if (normStr(optWood) !== wNeedNorm) continue;

      const vLen = normNumString(optLen);
      const vWid = normNumString(optWid);

      if (!Number.isFinite(vLen) || !Number.isFinite(vWid)) continue;

      if (Math.abs(vLen - Lneed) < 1e-6 && Math.abs(vWid - Wneed) < 1e-6) {
        return id;
      }
    }
    return null;
  }

  function boardFeet(lengthIn, widthIn, thicknessIn) {
    return (Number(lengthIn) * Number(widthIn) * Number(thicknessIn)) / 144;
  }
  //============ Section 6 End










  /* =========================
     SECTION 7 — Strip System
     - Renders strip rows and all action buttons (+/−/↑/↓).
     - Computes "last billable strip" and whether text is allowed.
     - Delegates all user interactions to the binding section.
     ========================= */

  /* =========================
     SECTION 7a — Render strips list (UI rows)
     - Generates the strip list table (wood + width + actions).
     - Controls visibility/labels for Carve/Edit Text button.
     - Updates select values after DOM is rendered.
     ========================= */
  let _lastRenderedStripCount = 0;

  function renderStrips() {
    const wrap = document.getElementById("cb-strips");
    if (!wrap) return;

    const isMobile = window.matchMedia && window.matchMedia("(max-width: 768px)").matches;

    // Split woods into groups
    const STANDARD_WOODS = WOODS.filter((w) => !ACCENT_WOODS.has(w));
    const ACCENT_WOODS_LIST = WOODS.filter((w) => ACCENT_WOODS.has(w));

    const woodOptionsHtml = WOODS.length
      ? `<option value="">Select wood…</option>` +
        `<optgroup label="STANDARD WOODS">` +
        STANDARD_WOODS.map((w) => `<option value="${w}">${w}</option>`).join("") +
        `</optgroup>` +
        `<optgroup label="ACCENT WOODS">` +
        ACCENT_WOODS_LIST.map((w) => `<option value="${w}">${w}</option>`).join("") +
        `</optgroup>`
      : `<option value="" selected>(No active woods)</option>`;

    const lastIndex = state.strips.length - 1;

    // Find last row that has a wood selected
    let lastBillableIndex = -1;
    for (let j = state.strips.length - 1; j >= 0; j--) {
      const woodName = (state.strips[j]?.wood || "").trim();
      if (woodName !== "") { lastBillableIndex = j; break; }
    }

    const lastBillableWidth = (lastBillableIndex >= 0) ? Number(state.strips[lastBillableIndex]?.width) : 0;
    const allowTextOnLast = Number.isFinite(lastBillableWidth) && lastBillableWidth >= 1;

    const STRIP_COL_W = isMobile ? 38 : 70;
    const WOOD_COL_W  = isMobile ? 82 : 140;
    const WID_COL_W   = isMobile ? 54 : 80;

    const GRID_COLS = `${STRIP_COL_W}px ${WOOD_COL_W}px ${WID_COL_W}px auto`;
    const GAP = isMobile ? "2px" : "8px";

    const ACTION_SQUARE = isMobile ? 22 : 32;
    const TEXT_BTN_W = isMobile ? 40 : 60;
    const TEXT_BTN_FONT_SIZE = isMobile ? 9 : 12;
    const ROW_PAD_Y = isMobile ? "8px" : "10px";
    const SELECT_PAD = isMobile ? "2px" : "6px";
    const SELECT_FONT = isMobile ? "11px" : "16px";
    const HEADER_FONT = isMobile ? "10px" : "13px";
    const NUM_FONT = isMobile ? "11px" : "16px";

    const PH = `<span style="display:inline-block;width:${ACTION_SQUARE}px;height:${ACTION_SQUARE}px;"></span>`;

    const headerRow = `
      <div style="
        display:grid;
        grid-template-columns:${GRID_COLS};
        gap:${GAP};
        padding:4px 0 4px 0;
        font-weight:800;
        font-size:${HEADER_FONT};
        color:#333;
        align-items:end;
      ">
        <div style="text-align:center;">Strip</div>

        <div style="display:flex;justify-content:flex-start;">
          <div style="width:${WOOD_COL_W}px;text-align:center;">Wood</div>
        </div>

        <div style="display:flex;justify-content:flex-start;">
          <div style="width:${WID_COL_W}px;text-align:center;">Width</div>
        </div>

        <div></div>
      </div>
    `;

    wrap.innerHTML =
      headerRow +
      state.strips
        .map((strip, i) => {
          const woodName = (strip.wood || "").trim();
          const isAccent = ACCENT_WOODS.has(woodName);
          const allowedWidthsForRow = isAccent ? ACCENT_WIDTHS : ALLOWED_WIDTHS;

          const isLastBlankRow = i === lastIndex && woodName === "";

          const showUp = !isLastBlankRow && i !== 0;
          const showDown = !isLastBlankRow && i < lastBillableIndex;
          const showRemove = !isLastBlankRow;
          const showInsert = !isLastBlankRow && i < lastBillableIndex;

          const widthDisabled = woodName === "";

          const shouldShowTextBtn = (i === lastBillableIndex && !isLastBlankRow && allowTextOnLast);

          const isTextEnabled = !!state.lastStripText?.enabled;
          const hasTextValue = String(state.lastStripText?.text || "").trim().length > 0;
          const isTextReallyOn = isTextEnabled && hasTextValue;

          const textBtnLabelTop = isTextReallyOn ? "Edit" : "Carve";
          const textBtnLabelBottom = "Text";

          return `
          <div style="
            display:grid;
            grid-template-columns:${GRID_COLS};
            align-items:end;
            gap:${GAP};
            padding:${ROW_PAD_Y} 0;
          ">

            <div style="display:flex;align-items:center;justify-content:center;font-weight:400;padding-top:${isMobile ? "4px" : "7px"};font-size:${NUM_FONT};">
              #${i + 1}
            </div>

            <div>
              <select data-strip-wood="${i}" class="cb-strip-wood"
                style="padding:${SELECT_PAD};width:${WOOD_COL_W}px;font-size:${SELECT_FONT};">
                ${woodOptionsHtml}
              </select>
            </div>

            <div>
              <select data-strip-index="${i}" class="cb-strip-width" ${widthDisabled ? "disabled" : ""}
                style="padding:${SELECT_PAD};width:${WID_COL_W}px;font-size:${SELECT_FONT};${widthDisabled ? "opacity:0.5;" : ""}">
                ${buildStripWidthOptionsFromList(allowedWidthsForRow, strip.width)}
              </select>
            </div>

            <div style="display:flex;align-items:center;gap:${isMobile ? "2px" : "6px"};white-space:nowrap;">

              ${showUp ? `<button class="cb-move-up" data-move-up="${i}" style="width:${ACTION_SQUARE}px;height:${ACTION_SQUARE}px;font-size:${isMobile ? "10px" : "16px"};padding:0;">↑</button>` : (showRemove ? PH : "")}

              ${showDown ? `<button class="cb-move-down" data-move-down="${i}" style="width:${ACTION_SQUARE}px;height:${ACTION_SQUARE}px;font-size:${isMobile ? "10px" : "16px"};padding:0;">↓</button>` : (showRemove ? PH : "")}

              ${showInsert ? `<button class="cb-insert-row" data-insert-row="${i}" style="width:${ACTION_SQUARE}px;height:${ACTION_SQUARE}px;font-size:${isMobile ? "10px" : "16px"};padding:0;">+</button>` : (showRemove ? PH : "")}

              ${showRemove ? `<button class="cb-remove-row" data-remove-row="${i}" style="width:${ACTION_SQUARE}px;height:${ACTION_SQUARE}px;font-size:${isMobile ? "10px" : "16px"};padding:0;">−</button>` : ""}

              ${
                shouldShowTextBtn
                  ? `<button class="cb-text-btn" data-text-btn="${i}"
                       style="margin-left:${isMobile ? "2px" : "6px"};width:${TEXT_BTN_W}px;height:${ACTION_SQUARE}px;border:1px solid #c9c9c9;border-radius:8px;background:#f7f7f7;font-weight:400;display:flex;flex-direction:column;align-items:center;justify-content:center;line-height:1;font-size:${TEXT_BTN_FONT_SIZE}px;padding:0;">
                       <span>${textBtnLabelTop}</span>
                       <span>${textBtnLabelBottom}</span>
                     </button>`
                  : ``
              }

            </div>

          </div>
        `;
        })
        .join("");

    wrap.querySelectorAll(".cb-strip-wood").forEach((sel) => {
      const idx = Number(sel.dataset.stripWood);
      sel.value = state.strips[idx]?.wood ?? "";
    });

    _lastRenderedStripCount = state.strips.length;
  }
  //============ Section 7a End










  /* =========================
     SECTION 7b — Bind strip handlers (events + text wizard)
     - Attaches all strip UI event listeners after each render.
     - Includes text wizard engine (modal + steps + validation).
     - Enforces max width, allowed widths, and text eligibility rules.
     ========================= */
  function bindStripHandlers() {
    const wrap = document.getElementById("cb-strips");
    if (!wrap) return;

    function scrollStripsToBottom() {
      setTimeout(() => {
        const w = document.getElementById("cb-strips");
        if (!w) return;
        w.scrollTop = w.scrollHeight;
      }, 0);
    }

    function scrollRowIntoView(rowIndex) {
      setTimeout(() => {
        const sel = document.querySelector(`.cb-strip-wood[data-strip-wood="${rowIndex}"]`);
        if (!sel) return;
        try {
          sel.scrollIntoView({ block: "center", behavior: "smooth" });
          sel.focus();
        } catch (e) {}
      }, 0);
    }

    function getBillableWidthWithOverride(idx, nextWood, nextWidth) {
      let total = 0;
      for (let i = 0; i < state.strips.length; i++) {
        const s = state.strips[i];
        const wood = (i === idx) ? String(nextWood ?? "") : String(s.wood ?? "");
        if (wood.trim() === "") continue;

        const w = (i === idx) ? Number(nextWidth) : Number(s.width);
        total += num(w, 0);
      }
      return total;
    }

    function alertMaxWidth() {
      alert(`Maximum ${TOTAL_WIDTH_MAX}" width. Please reduce a strip width.`);
    }

    function closestAllowedWidth(currentWidth, allowedList) {
      const allowed = Array.isArray(allowedList) ? allowedList.map(Number).filter(Number.isFinite) : [];
      if (!allowed.length) return Number.isFinite(currentWidth) ? currentWidth : STRIP_MIN;

      const cur = Number(currentWidth);
      if (!Number.isFinite(cur)) return allowed[0];

      let best = allowed[0];
      let bestDist = Math.abs(cur - best);

      for (let i = 1; i < allowed.length; i++) {
        const v = allowed[i];
        const d = Math.abs(cur - v);
        if (d < bestDist) {
          best = v;
          bestDist = d;
        }
      }
      return best;
    }

    function widthIsAllowed(width, allowedList) {
      const w = Number(width);
      if (!Number.isFinite(w)) return false;
      return (allowedList || []).some((v) => Math.abs(Number(v) - w) < 1e-9);
    }

    function cbbCountLettersOnly(s) {
      const m = String(s || "").match(/[A-Za-z]/g);
      return m ? m.length : 0;
    }

    // ✅ fonts now: arial / georgia / dancing
    function cbbFontFromKey(fontKey) {
      const k = String(fontKey || "arial").toLowerCase();
      if (k === "georgia") return "Georgia, serif";
      if (k === "dancing") return `"Dancing Script", cursive`;
      return "Arial, Helvetica, sans-serif";
    }

    function cbbClampQuarterInches(v, minV, maxV) {
      const n = Number(v);
      if (!Number.isFinite(n)) return minV;
      const clamped = Math.max(minV, Math.min(maxV, n));
      return Math.round(clamped * 4) / 4;
    }

    // --- NEW: VCarve-style "true outline height" sizing + fit check (unit-accurate, not preview-dependent) ---
    const CBB_TEXT_MAX_CHARS = 28;
    const CBB_TEXT_PAD_IN = 0.25;
    const CBB_TEXT_MEASURE_PPI = 1000;

    const __cbbMeasureCanvas = document.createElement("canvas");
    __cbbMeasureCanvas.width = 2000;
    __cbbMeasureCanvas.height = 400;
    const __cbbMeasureCtx = __cbbMeasureCanvas.getContext("2d");

    function cbbGetTextOutlineHeightPx(ctx, text) {
      const m = ctx.measureText(text);
      const a = Number(m.actualBoundingBoxAscent);
      const d = Number(m.actualBoundingBoxDescent);
      if (Number.isFinite(a) && Number.isFinite(d) && (a + d) > 0) return a + d;
      return 100;
    }

    function cbbFontSizePxForLetterHeight(text, fontFamily, letterHeightIn) {
      if (!__cbbMeasureCtx) return 40;

      const baseSize = 100;

      __cbbMeasureCtx.textBaseline = "alphabetic";
      __cbbMeasureCtx.font = `400 ${baseSize}px ${fontFamily}`;

      const safeText = String(text || "Hype").trim();
      const measuredH = cbbGetTextOutlineHeightPx(__cbbMeasureCtx, safeText);

      const targetH = Math.max(1, Number(letterHeightIn) * CBB_TEXT_MEASURE_PPI);
      const scale = targetH / Math.max(1, measuredH);

      return Math.max(1, baseSize * scale);
    }

    function cbbTextFitsAtLetterHeight(text, fontFamily, letterHeightIn, boardLengthIn) {
      if (!__cbbMeasureCtx) return true;

      const L = Number(boardLengthIn);
      if (!Number.isFinite(L) || L <= 0) return true;

      const safeText = String(text || "").trim();
      if (!safeText) return false;

      const fontSizePx = cbbFontSizePxForLetterHeight(safeText, fontFamily, letterHeightIn);

      __cbbMeasureCtx.textBaseline = "alphabetic";
      __cbbMeasureCtx.font = `400 ${fontSizePx}px ${fontFamily}`;

      const wPx = __cbbMeasureCtx.measureText(safeText).width;

      const maxWPx = Math.max(1, (L - (2 * CBB_TEXT_PAD_IN)) * CBB_TEXT_MEASURE_PPI);
      return wPx <= maxWPx;
    }

    function cbbBuildLetterHeightOptionsThatFit(minH, maxH, selectedH, text, fontFamily, boardLengthIn) {
      const minQ = Math.ceil(minH * 4);
      const maxQ = Math.floor(maxH * 4);

      const valid = [];
      for (let q = minQ; q <= maxQ; q++) {
        const v = q / 4;
        if (cbbTextFitsAtLetterHeight(text, fontFamily, v, boardLengthIn)) valid.push(v);
      }

      if (!valid.length) valid.push(minH);

      const safeSelected = (function () {
        const s = cbbClampQuarterInches(selectedH, minH, maxH);
        let best = valid[0];
        let bestDist = Math.abs(s - best);
        for (let i = 1; i < valid.length; i++) {
          const d = Math.abs(s - valid[i]);
          if (d < bestDist) {
            best = valid[i];
            bestDist = d;
          }
        }
        return best;
      })();

      const html = valid
        .map((v) => {
          const isSel = Math.abs(v - safeSelected) < 1e-9 ? "selected" : "";
          const label = (function () {
            const whole = Math.floor(v);
            const frac = Math.round((v - whole) * 4) / 4;
            if (frac === 0) return `${whole}"`;
            if (frac === 0.25) return `${whole}-1/4"`;
            if (frac === 0.5) return `${whole}-1/2"`;
            if (frac === 0.75) return `${whole}-3/4"`;
            return `${v}"`;
          })();
          return `<option value="${v}" ${isSel}>${label}</option>`;
        })
        .join("");

      return { html, selected: safeSelected, count: valid.length };
    }

    function cbbEnsureTextModalRoot() {
      const root = document.getElementById("cbb-text-modal-root");
      if (!root) return null;

      if (root.dataset.cbbBuilt === "1") return root;
      root.dataset.cbbBuilt = "1";

      root.innerHTML = `
        <div id="cbbTextModal" style="display:none;position:fixed;inset:0;z-index:99999;background:${COLOR_MODAL_BACKDROP};align-items:center;justify-content:center;padding:18px;">
          <div style="width:min(520px, 100%);background:${COLOR_MODAL_PANEL_BG};border:1px solid ${COLOR_MODAL_BORDER};border-radius:12px;box-shadow:0 12px 30px rgba(0,0,0,0.25);padding:16px;">
            <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;">
              <div id="cbbTextTitle" style="font-weight:900;font-size:16px;">Text on last strip</div>
              <button id="cbbTextClose" type="button" style="border:1px solid ${COLOR_UTILITY_BTN_BORDER};background:${COLOR_UTILITY_BTN_BG};border-radius:8px;padding:6px 10px;font-weight:800;">X</button>
            </div>

            <div id="cbbTextBody" style="margin-top:12px;"></div>

            <div style="margin-top:14px;display:flex;justify-content:space-between;gap:10px;align-items:center;">
              <div style="display:flex;gap:10px;align-items:center;">
                <button id="cbbTextBack" type="button" style="border:1px solid ${COLOR_UTILITY_BTN_BORDER};background:${COLOR_UTILITY_BTN_BG};border-radius:8px;padding:8px 12px;font-weight:800;">Previous Screen</button>
                <button id="cbbTextDelete" type="button" style="display:none;border:1px solid #c9c9c9;background:#fff;border-radius:8px;padding:8px 12px;font-weight:900;">Delete Text</button>
              </div>
              <div style="display:flex;gap:10px;">
                <button id="cbbTextCancel" type="button" style="border:1px solid ${COLOR_UTILITY_BTN_BORDER};background:${COLOR_UTILITY_BTN_BG};border-radius:8px;padding:8px 12px;font-weight:800;">Cancel</button>
                <button id="cbbTextNext" type="button" style="border:1px solid ${COLOR_PRIMARY_BTN};background:${COLOR_PRIMARY_BTN};color:#fff;border-radius:8px;padding:8px 12px;font-weight:900;">Next</button>
              </div>
            </div>

            <div id="cbbTextFoot" style="margin-top:10px;font-size:12px;color:#555;text-align:center;"></div>
          </div>
        </div>
      `;
      return root;
    }

    function cbbOpenTextWizard(initial, stripWidthIn, opts) {
      return new Promise((resolve) => {
        const root = cbbEnsureTextModalRoot();
        if (!root) return resolve(null);

        const modal = document.getElementById("cbbTextModal");
        const body = document.getElementById("cbbTextBody");
        const foot = document.getElementById("cbbTextFoot");
        const btnClose = document.getElementById("cbbTextClose");
        const btnBack = document.getElementById("cbbTextBack");
        const btnCancel = document.getElementById("cbbTextCancel");
        const btnNext = document.getElementById("cbbTextNext");
        const btnDelete = document.getElementById("cbbTextDelete");

        if (!modal || !body || !foot || !btnClose || !btnBack || !btnCancel || !btnNext || !btnDelete) {
          return resolve(null);
        }

        const sw = Number(stripWidthIn);
        const stripW = Number.isFinite(sw) ? sw : NaN;

        const model = {
          text: String(initial?.text || "").trim(),
          align: (String(initial?.align || "center") === "left" || String(initial?.align || "center") === "right")
            ? String(initial.align)
            : "center",
          fontKey: (String(initial?.fontKey || "arial") === "georgia" || String(initial?.fontKey || "arial") === "dancing")
            ? String(initial.fontKey)
            : "arial",
          letterHeightIn: Number.isFinite(Number(initial?.letterHeightIn))
            ? Number(initial.letterHeightIn)
            : 0.5,
        };

        const hasLetterHeightStep = Number.isFinite(stripW) && stripW > 1.0;
        let step = 1;

        const wantsDeleteButton = !!(opts && opts.showDelete === true);

        // Show Delete ONLY when editing existing text
        btnDelete.style.display = wantsDeleteButton ? "" : "none";

        function close(result) {
          modal.style.display = "none";
          resolve(result || null);
        }

        function render() {
          btnBack.style.visibility = (step === 1) ? "hidden" : "visible";

          if (step === 1) {
            const letters = String(model.text || "").length;
            body.innerHTML = `
              <div style="font-weight:800;margin-bottom:6px;">Enter text</div>
              <input id="cbbTextInput" type="text" maxlength="${CBB_TEXT_MAX_CHARS}" value="${model.text.replace(/"/g, "&quot;")}"
                style="width:100%;padding:10px;border:1px solid ${COLOR_MODAL_BORDER};border-radius:10px;font-size:16px;" />
              <div style="margin-top:8px;font-size:12px;color:#555;">
                Max ${CBB_TEXT_MAX_CHARS} characters (spaces included).
              </div>
            `;
            foot.textContent = `Characters counted: ${letters}`;
            btnNext.textContent = "Next";
          }

          if (step === 2) {
            body.innerHTML = `
              <div style="font-weight:800;margin-bottom:10px;">Choose alignment</div>
              <div style="display:flex;gap:10px;flex-wrap:wrap;">
                <button type="button" class="cbbAlignBtn" data-align="left"
                  style="padding:10px 12px;border-radius:10px;border:1px solid ${COLOR_MODAL_BORDER};background:${model.align === "left" ? COLOR_UTILITY_BTN_HOVER_BG : COLOR_UTILITY_BTN_BG};font-weight:900;">
                  Left
                </button>
                <button type="button" class="cbbAlignBtn" data-align="center"
                  style="padding:10px 12px;border-radius:10px;border:1px solid ${COLOR_MODAL_BORDER};background:${model.align === "center" ? COLOR_UTILITY_BTN_HOVER_BG : COLOR_UTILITY_BTN_BG};font-weight:900;">
                  Center
                </button>
                <button type="button" class="cbbAlignBtn" data-align="right"
                  style="padding:10px 12px;border-radius:10px;border:1px solid ${COLOR_MODAL_BORDER};background:${model.align === "right" ? COLOR_UTILITY_BTN_HOVER_BG : COLOR_UTILITY_BTN_BG};font-weight:900;">
                  Right
                </button>
              </div>
            `;
            foot.textContent = "";
            btnNext.textContent = "Next";

            body.querySelectorAll(".cbbAlignBtn").forEach((b) => {
              b.addEventListener("click", () => {
                model.align = b.dataset.align || "center";
                render();
              });
            });
          }

          if (step === 3) {
            const sample = model.text || "Sample";
            body.innerHTML = `
              <div style="font-weight:800;margin-bottom:10px;">Choose font</div>

              <button type="button" class="cbbFontBtn" data-font="arial"
                style="width:100%;text-align:left;padding:10px 12px;border-radius:12px;border:1px solid ${COLOR_MODAL_BORDER};background:${model.fontKey === "arial" ? COLOR_UTILITY_BTN_HOVER_BG : COLOR_UTILITY_BTN_BG};">
                <div style="font-weight:900;margin-bottom:4px;">Arial</div>
                <div style="font-family:Arial, Helvetica, sans-serif;font-size:18px;color:${COLOR_TEXT_BURN};">${sample}</div>
              </button>

              <div style="height:10px;"></div>

              <button type="button" class="cbbFontBtn" data-font="georgia"
                style="width:100%;text-align:left;padding:10px 12px;border-radius:12px;border:1px solid ${COLOR_MODAL_BORDER};background:${model.fontKey === "georgia" ? COLOR_UTILITY_BTN_HOVER_BG : COLOR_UTILITY_BTN_BG};">
                <div style="font-weight:900;margin-bottom:4px;">Georgia</div>
                <div style="font-family:Georgia, serif;font-size:18px;color:${COLOR_TEXT_BURN};">${sample}</div>
              </button>

              <div style="height:10px;"></div>

              <button type="button" class="cbbFontBtn" data-font="dancing"
                style="width:100%;text-align:left;padding:10px 12px;border-radius:12px;border:1px solid ${COLOR_MODAL_BORDER};background:${model.fontKey === "dancing" ? COLOR_UTILITY_BTN_HOVER_BG : COLOR_UTILITY_BTN_BG};">
                <div style="font-weight:900;margin-bottom:4px;">Dancing Script</div>
                <div style="font-family:'Dancing Script', cursive;font-weight:700;font-size:18px;color:${COLOR_TEXT_BURN};">${sample}</div>
              </button>
            `;
            foot.textContent = "";
            btnNext.textContent = hasLetterHeightStep ? "Next" : "Done";

            body.querySelectorAll(".cbbFontBtn").forEach((b) => {
              b.addEventListener("click", () => {
                model.fontKey = b.dataset.font || "arial";
                render();
              });
            });
          }

          if (step === 4) {
            const minH = 0.5;
            const maxH = Math.min(1.0, Math.max(0.5, stripW - 0.5));

            model.letterHeightIn = cbbClampQuarterInches(model.letterHeightIn, minH, maxH);

            const fontFamily = cbbFontFromKey(model.fontKey);
            const boardLen = Number(state.boardLength);

            const build = cbbBuildLetterHeightOptionsThatFit(
              minH,
              maxH,
              model.letterHeightIn,
              model.text,
              fontFamily,
              boardLen
            );

            model.letterHeightIn = build.selected;

            body.innerHTML = `
              <div style="font-weight:800;margin-bottom:8px;">Letter height</div>
              <div style="margin-bottom:10px;font-size:13px;color:#333;">
                Heights shown here are only the ones that <b>fit</b> your current text within the <b>${boardLen}"</b> board length.
              </div>

              <select id="cbbLetterHeightSel"
                style="width:100%;padding:10px;border:1px solid ${COLOR_MODAL_BORDER};border-radius:10px;font-size:18px;font-weight:700;">
                ${build.html}
              </select>
            `;
            foot.textContent = "";
            btnNext.textContent = "Done";

            const sel = document.getElementById("cbbLetterHeightSel");
            if (sel) {
              sel.addEventListener("change", () => {
                model.letterHeightIn = Number(sel.value);
              });
            }
          }
        }

        function syncStep1Text() {
          const inp = document.getElementById("cbbTextInput");
          if (!inp) return;
          model.text = String(inp.value || "").trim();
        }

        function validateStep1() {
          syncStep1Text();
          const letters = String(model.text || "").length;

          if (letters <= 0) {
            alert("Please enter at least 1 character.");
            return false;
          }
          if (letters > CBB_TEXT_MAX_CHARS) {
            alert(`Maximum ${CBB_TEXT_MAX_CHARS} characters. Please shorten your text.`);
            return false;
          }
          return true;
        }

        function onNext() {
          if (step === 1) {
            if (!validateStep1()) return;
            step = 2;
            render();
            return;
          }
          if (step === 2) {
            step = 3;
            render();
            return;
          }
          if (step === 3) {
            if (hasLetterHeightStep) {
              step = 4;
              render();
              return;
            }

            syncStep1Text();
            const letters = String(model.text || "").length;
            close({
              text: model.text,
              align: model.align,
              fontKey: model.fontKey,
              fontFamily: cbbFontFromKey(model.fontKey),
              lettersCount: letters,
              letterHeightIn: 0.5,
            });
            return;
          }
          if (step === 4) {
            syncStep1Text();
            const letters = String(model.text || "").length;

            const minH = 0.5;
            const maxH = Math.min(1.0, Math.max(0.5, stripW - 0.5));
            const lh = cbbClampQuarterInches(model.letterHeightIn, minH, maxH);

            close({
              text: model.text,
              align: model.align,
              fontKey: model.fontKey,
              fontFamily: cbbFontFromKey(model.fontKey),
              lettersCount: letters,
              letterHeightIn: lh,
            });
            return;
          }
        }

        function onBack() {
          if (step <= 1) return;
          step = step - 1;
          render();
        }

        function onCancel() {
          close(null);
        }

        function onDelete() {
          // Return a special result that tells caller to delete existing text
          close({ deleteText: true });
        }

        btnClose.onclick = onCancel;
        btnCancel.onclick = onCancel;
        btnBack.onclick = onBack;
        btnNext.onclick = onNext;
        btnDelete.onclick = onDelete;

        modal.style.display = "flex";
        render();
      });
    }

    function cbbGetLastBillableIndexLocal() {
      for (let j = state.strips.length - 1; j >= 0; j--) {
        const woodName = (state.strips[j]?.wood || "").trim();
        if (woodName !== "") return j;
      }
      return -1;
    }

    function cbbClearTextState_NoUI() {
      if (!state.lastStripText) return;
      state.lastStripText.enabled = false;
      state.lastStripText.text = "";
      state.lastStripText.lettersCount = 0;
      state.lastStripText.letterHeightIn = 0.5;
      state.lastStripText.fontFamily = "";
    }

    // Width changes
    wrap.querySelectorAll(".cb-strip-width").forEach((sel) => {
      sel.addEventListener("change", (e) => {
        clearMirrorUndo();

        const idx = Number(e.target.dataset.stripIndex);
        const prev = Number(state.strips[idx]?.width);
        const next = Number(e.target.value);

        const wouldTotal = getBillableWidthWithOverride(idx, state.strips[idx]?.wood, next);
        if (wouldTotal > TOTAL_WIDTH_MAX + 1e-9) {
          state.strips[idx].width = prev;
          e.target.value = String(prev);
          alertMaxWidth();
          updateTotals();
          return;
        }

        state.strips[idx].width = next;

        // ✅ CRITICAL FIX:
        // If last billable strip width becomes < 1", clear text AND rerender so button flips back.
        const lastBillableIndex = cbbGetLastBillableIndexLocal();
        if (lastBillableIndex >= 0) {
          const lastWidthIn = Number(state.strips[lastBillableIndex]?.width);
          const textWasEnabled = !!state.lastStripText?.enabled;

          if (textWasEnabled && Number.isFinite(lastWidthIn) && lastWidthIn < 1) {
            cbbClearTextState_NoUI();
            saveState();

            renderStrips();
            bindStripHandlers();
            updateTotals();
            return;
          }
        }

        updateTotals();
      });
    });

    // Wood changes
    wrap.querySelectorAll(".cb-strip-wood").forEach((sel) => {
      sel.addEventListener("change", (e) => {
        clearMirrorUndo();

        const idx = Number(e.target.dataset.stripWood);
        const newWood = String(e.target.value || "");

        const wouldTotal = getBillableWidthWithOverride(idx, newWood, state.strips[idx]?.width);
        if (newWood.trim() !== "" && wouldTotal > TOTAL_WIDTH_MAX + 1e-9) {
          state.strips[idx].wood = "";
          alertMaxWidth();

          renderStrips();
          bindStripHandlers();
          updateTotals();
          return;
        }

        state.strips[idx].wood = newWood;

        if (newWood.trim() !== "") {
          const woodName = newWood.trim();
          const isAccent = ACCENT_WOODS.has(woodName);
          const allowedWidthsForRow = isAccent ? ACCENT_WIDTHS : ALLOWED_WIDTHS;

          const curW = Number(state.strips[idx]?.width);
          if (!widthIsAllowed(curW, allowedWidthsForRow)) {
            state.strips[idx].width = closestAllowedWidth(curW, allowedWidthsForRow);
          }
        }

        renderStrips();
        bindStripHandlers();

        const isLast = idx === state.strips.length - 1;
        const pickedWood = newWood.trim() !== "";

        if (pickedWood && isLast && state.strips.length < MAX_STRIPS) {
          state.strips.push({ width: 1.0, wood: "" });

          renderStrips();
          bindStripHandlers();
          updateTotals();

          scrollStripsToBottom();
          return;
        }

        updateTotals();
      });
    });

    wrap.querySelectorAll(".cb-move-up").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        clearMirrorUndo();

        const idx = Number(e.target.dataset.moveUp);
        if (idx <= 0) return;

        const tmp = state.strips[idx - 1];
        state.strips[idx - 1] = state.strips[idx];
        state.strips[idx] = tmp;

        renderStrips();
        bindStripHandlers();
        updateTotals();
      });
    });

    wrap.querySelectorAll(".cb-move-down").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        clearMirrorUndo();

        const idx = Number(e.target.dataset.moveDown);
        if (idx >= state.strips.length - 1) return;

        const tmp = state.strips[idx + 1];
        state.strips[idx + 1] = state.strips[idx];
        state.strips[idx] = tmp;

        renderStrips();
        bindStripHandlers();
        updateTotals();
      });
    });

    wrap.querySelectorAll(".cb-remove-row").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        clearMirrorUndo();

        const idx = Number(e.target.dataset.removeRow);
        if (!Number.isFinite(idx)) return;
        if (state.strips.length <= 1) return;

        state.strips.splice(idx, 1);

        if (!state.strips.length) {
          state.strips = [{ width: 1.0, wood: "" }];
        }

        renderStrips();
        bindStripHandlers();
        updateTotals();
      });
    });

    wrap.querySelectorAll(".cb-insert-row").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        clearMirrorUndo();

        const idx = Number(e.target.dataset.insertRow);
        if (!Number.isFinite(idx)) return;

        if (state.strips.length >= MAX_STRIPS) {
          alert(`Maximum ${MAX_STRIPS} strips.`);
          return;
        }

        const insertAt = Math.min(idx, state.strips.length);

        state.strips.splice(insertAt, 0, { width: 1.0, wood: "" });

        renderStrips();
        bindStripHandlers();
        updateTotals();

        scrollRowIntoView(insertAt);
      });
    });

    // TEXT button (Carve/Edit)
    wrap.querySelectorAll(".cb-text-btn").forEach((btn) => {
      btn.addEventListener("click", async () => {
        clearMirrorUndo();

        const lastBillableIndex = cbbGetLastBillableIndexLocal();
        if (lastBillableIndex < 0) return;

        const lastWidthIn = Number(state.strips[lastBillableIndex]?.width);

        if (!Number.isFinite(lastWidthIn) || lastWidthIn < 1) {
          alert('Text is only allowed when the last strip width is at least 1.00".');
          return;
        }

        const isEnabled = !!state.lastStripText?.enabled;
        const hasText = String(state.lastStripText?.text || "").trim().length > 0;
        const isEditing = isEnabled && hasText;

        const initial = state.lastStripText || {};
        const result = await cbbOpenTextWizard(initial, lastWidthIn, { showDelete: isEditing });

        if (!result) return;

        // DELETE TEXT (only possible when editing)
        if (result.deleteText === true) {
          cbbClearTextState_NoUI();
          saveState();
          renderStrips();
          bindStripHandlers();
          updateTotals();
          return;
        }

        // SAVE / UPDATE TEXT
        state.lastStripText.enabled = true;
        state.lastStripText.text = String(result.text || "");
        state.lastStripText.align = String(result.align || "center");
        state.lastStripText.fontKey = String(result.fontKey || "arial");
        state.lastStripText.fontFamily = String(result.fontFamily || cbbFontFromKey(result.fontKey || "arial"));
        state.lastStripText.lettersCount = Number(result.lettersCount || 0);
        state.lastStripText.letterHeightIn = Number(result.letterHeightIn || 0.5);

        saveState();
        renderStrips();
        bindStripHandlers();
        updateTotals();
      });
    });
  }
  //============ Section 7b End










  /* =========================
     SECTION 8 — Preview Texture Helpers (stretched, no tiling)
     - Loads images with CORS enabled for safe canvas operations.
     - Generates stretched texture data URLs for consistent scaling.
     - Uses an in-memory cache to avoid repeated work per size.
     ========================= */
  const _cbbTextureCache = new Map();

  function _loadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    });
  }

  async function _getStretchedTextureDataUrl(url, targetW, targetH) {
    const w = Math.max(1, Math.round(targetW));
    const h = Math.max(1, Math.round(targetH));
    const key = `${url}|${w}x${h}`;

    if (_cbbTextureCache.has(key)) return _cbbTextureCache.get(key);

    const img = await _loadImage(url);

    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;

    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingEnabled = true;
    try {
      ctx.imageSmoothingQuality = "high";
    } catch (e) {}

    ctx.clearRect(0, 0, w, h);
    ctx.drawImage(img, 0, 0, w, h);

    const dataUrl = canvas.toDataURL("image/jpeg", 0.92);
    _cbbTextureCache.set(key, dataUrl);
    return dataUrl;
  }
  //============ Section 8 End










  /* =========================
     SECTION 9 — Totals + Preview Rendering (async-safe)
     - Persists state and updates button states each run.
     - Computes totals, validates selections, and updates status message.
     - Renders the board preview DOM (strips + textures + gutter numbers).
     ========================= */
  let _updateTotalsRunId = 0;

  async function updateTotals() {
    const myRunId = ++_updateTotalsRunId;

    saveState();
    updateButtonStates();



    /* =========================
       SECTION 9a — Totals + validation + status text
       - Computes billable width and strip count.
       - Checks for missing PPBF pricing in Shopify.
       - Updates the status message with guidance and warnings.
       - Calculates and displays live board price from Shopify handle-based product data.
       ========================= */
    const billableStrips = state.strips.filter((s) => (s.wood || "").trim() !== "");
    const billableWidth = billableStrips.reduce((a, s) => a + num(s.width, 0), 0);
    const billableStripCount = billableStrips.length;

    const totalEl = document.getElementById("cb-total-width");
    if (totalEl) totalEl.textContent = billableWidth.toFixed(2);

    let hasMissingPrice = false;
    for (const s of billableStrips) {
      const wood = (s.wood || "").trim();
      const ppbf = Number(WOOD_PPBF[wood]);
      if (!Number.isFinite(ppbf) || ppbf <= 0) {
        hasMissingPrice = true;
        break;
      }
    }

    const widthOk = billableWidth <= TOTAL_WIDTH_MAX;
    const validForCart = widthOk && billableStripCount > 0 && !hasMissingPrice;

    // --- LIVE PRICE CALCULATION (USE SAME SHOPIFY HANDLE-BASED SOURCE AS CART LOGIC) ---
    let livePrice = 0;
    let livePriceReady = true;

    try {
      const { stripHandle, packHandle, textHandle } = cbbGetHandlesFromMount();

      if (!stripHandle || !packHandle) {
        livePriceReady = false;
      } else {
        const stripMap = await cbbLoadVariantsByHandle(stripHandle);

        const grouped = cbbGroupStripsToCounts(
          billableStrips.map((s) => ({
            wood: cbbCleanOptionValue(s.wood),
            length: cbbNormalizeNumberString(state.boardLength),
            width: cbbNormalizeNumberString(s.width),
          }))
        );

        const stripProductRes = await fetch(`/products/${stripHandle}.js`, {
          credentials: "same-origin",
        });

        if (!stripProductRes.ok) {
          livePriceReady = false;
        } else {
          const stripProduct = await stripProductRes.json();
          const stripVariantsById = new Map(
            (stripProduct.variants || []).map((v) => [Number(v.id), v])
          );

          grouped.forEach((qty, key) => {
            const variantId = stripMap.get(key);
            const variant = stripVariantsById.get(Number(variantId));
            const cents = Number(variant?.price);

            if (!Number.isFinite(cents)) {
              livePriceReady = false;
              return;
            }

            livePrice += (cents / 100) * qty;
          });
        }

        // Packaging price (exactly one when there are strips)
        if (livePriceReady && billableStripCount > 0) {
          const packProduct = await cbbLoadPackProductByHandle(packHandle);
          const packCents = Number(packProduct?.variants?.[0]?.price);

          if (Number.isFinite(packCents)) {
            livePrice += packCents / 100;
          } else {
            livePriceReady = false;
          }
        }

        // Text add-on price (one line only if enabled)
        const textCfg = state.lastStripText || {};
        const textEnabled = !!textCfg.enabled;
        const textVal = String(textCfg.text || "").trim();
        const letters = cbbLettersOnlyCount(textVal);
        const wantsTextCharge = textEnabled && textVal && letters > 0;

        if (livePriceReady && wantsTextCharge) {
          if (!textHandle) {
            livePriceReady = false;
          } else {
            const textProduct = await cbbLoadTextProductByHandle(textHandle);
            const textCents = Number(textProduct?.variants?.[0]?.price);

            if (Number.isFinite(textCents)) {
              livePrice += textCents / 100;
            } else {
              livePriceReady = false;
            }
          }
        }
      }
    } catch (e) {
      livePriceReady = false;
    }

    const livePriceEl = document.getElementById("cb-live-price");
    if (livePriceEl) {
      if (billableStripCount === 0 || !widthOk) {
        livePriceEl.textContent = "$0.00";
      } else if (!livePriceReady) {
        livePriceEl.textContent = "Loading...";
      } else {
        livePriceEl.textContent = `$${livePrice.toFixed(2)}`;
      }
    }

    const msg = document.getElementById("cb-width-msg");
    if (msg) {
      msg.textContent = "";
      msg.innerHTML = "";
      msg.style.color = "";
      msg.style.fontWeight = "";
      msg.style.textAlign = "";
      msg.style.display = "";

      if (billableStripCount === 0) {
        msg.innerHTML =
          `<span style="font-weight:900;">Accent woods -</span> ` +
          `Padauk, Goibao, Purple Heart: 1/2" & 1" widths only.` +
          `<br>` +
          `Standard woods offer wider sizes.`;

        msg.style.color = "red";
        msg.style.textAlign = "center";
      }
      else if (hasMissingPrice) {
        msg.textContent = `One or more selected woods are missing “Price per board foot” in Shopify. This design can’t be priced yet.`;
        msg.style.color = "red";
        msg.style.fontWeight = "600";
        msg.style.textAlign = "center";
      } else if (!widthOk) {
        msg.textContent = `Maximum ${TOTAL_WIDTH_MAX}" Width`;
        msg.style.color = "red";
        msg.style.fontWeight = "600";
        msg.style.textAlign = "center";
      } else if (!livePriceReady) {
        msg.textContent = `Unable to load one or more Shopify prices for this design right now.`;
        msg.style.color = "red";
        msg.style.fontWeight = "600";
        msg.style.textAlign = "center";
      } else if (billableStripCount > 0) {
        msg.innerHTML =
          `<span style="font-weight:900;">Accent woods -</span> ` +
          `Padauk, Goibao, Purple Heart: 1/2" and 1" widths only.` +
          `<br>` +
          `Other woods offer wider sizes.`;

        msg.style.color = "#444";
        msg.style.fontWeight = "400";
        msg.style.textAlign = "center";
      } else {
        msg.textContent = "";
      }
    }
    //============ Section 9a End





    /* =========================
       SECTION 9b — Preview board rendering (scale-aware)
       - Builds the preview board DOM and sizes it based on length/width.
       - Applies wood textures as stretched backgrounds per strip.
       - Renders strip number gutter aligned with strip heights.
       ========================= */
    const preview = document.getElementById("cb-preview");
    if (preview) {
      if (myRunId !== _updateTotalsRunId) return;

      preview.style.position = "relative";
      preview.style.background = "#fff";
      preview.style.display = "flex";
      preview.style.flexDirection = "column";
      preview.style.justifyContent = "center";
      preview.style.alignItems = "center";
      preview.style.padding = "14px";
      preview.style.overflow = "visible";
      preview.innerHTML = "";

      const selectedStrips = state.strips
        .map((s, idx) => ({ s, idx }))
        .filter(({ s, idx }) => idx === 0 || (s.wood || "").trim() !== "");

      const L = Math.max(0.01, num(state.boardLength, 16));
      const Wsum = Math.max(0.01, selectedStrips.reduce((a, item) => a + num(item.s.width, 0), 0));

      let widthRatio = 0.33;
      if (Math.abs(L - 12) < 0.001) widthRatio = 0.25;
      else if (Math.abs(L - 16) < 0.001) widthRatio = 0.33;
      else if (Math.abs(L - 20) < 0.001) widthRatio = 0.42;

      const fullAvailW = Math.max(200, preview.clientWidth - 40);
      const boardAvailW = Math.max(160, Math.round(fullAvailW * widthRatio));

      const ppi = boardAvailW / L;
      const boardPxW = Math.max(10, Math.round(L * ppi));
      const boardPxH = Math.max(10, Math.round(Wsum * ppi));

      const BOARD_SCALE = 1.7;

      const scaledBoardPxW = Math.round(boardPxW * BOARD_SCALE);
      const scaledBoardPxH = Math.round(boardPxH * BOARD_SCALE);

      preview.style.minHeight = Math.max(140, scaledBoardPxH + 20) + "px";

      const wrapper = document.createElement("div");
      wrapper.style.display = "flex";
      wrapper.style.justifyContent = "center";
      wrapper.style.alignItems = "flex-start";
      wrapper.style.gap = "14px";
      wrapper.style.minHeight = scaledBoardPxH + "px";

      const baseGutterW = 42;
      const gutterWrapW = Math.round(baseGutterW * BOARD_SCALE);

      const gutterWrap = document.createElement("div");
      gutterWrap.style.width = gutterWrapW + "px";
      gutterWrap.style.height = scaledBoardPxH + "px";
      gutterWrap.style.display = "flex";
      gutterWrap.style.justifyContent = "flex-end";
      gutterWrap.style.alignItems = "flex-start";

      const gutter = document.createElement("div");
      gutter.style.display = "flex";
      gutter.style.flexDirection = "column";
      gutter.style.alignItems = "flex-end";
      gutter.style.fontWeight = "400";
      gutter.style.fontSize = Math.round(12 * BOARD_SCALE) + "px";
      gutter.style.color = "#555";
      gutterWrap.appendChild(gutter);

      const boardWrap = document.createElement("div");
      boardWrap.style.width = scaledBoardPxW + "px";
      boardWrap.style.height = scaledBoardPxH + "px";
      boardWrap.style.display = "flex";
      boardWrap.style.alignItems = "flex-start";
      boardWrap.style.justifyContent = "flex-start";

      const board = document.createElement("div");
      board.style.transform = `scale(${BOARD_SCALE})`;
      board.style.transformOrigin = "top left";
      board.style.width = boardPxW + "px";
      board.style.height = boardPxH + "px";
      board.style.display = "flex";
      board.style.flexDirection = "column";
      board.style.border = "1px solid rgba(0,0,0,0.12)";
      board.style.borderRadius = "3px";
      board.style.overflow = "hidden";
      board.style.boxShadow = "0 3px 10px rgba(0,0,0,0.24), inset 1px 1px 0 rgba(255,255,255,0.30), inset -1px -1px 0 rgba(0,0,0,0.12)";
      board.style.background = "#f3f3f3";

      for (const item of selectedStrips) {
        if (myRunId !== _updateTotalsRunId) return;

        const s = item.s;
        const rowNumber = item.idx + 1;

        const stripHIn = Math.max(0, num(s.width, 0));
        const stripPxH = Math.max(1, Math.round(stripHIn * ppi));

        const labelPxH = Math.max(1, Math.round(stripPxH * BOARD_SCALE));

const numLabel = document.createElement("div");
numLabel.textContent = `#${rowNumber}`;
numLabel.style.height = labelPxH + "px";
numLabel.style.display = "flex";
numLabel.style.alignItems = "center";
numLabel.style.justifyContent = "flex-end";
numLabel.style.fontSize = window.innerWidth <= 768
  ? Math.round(6 * BOARD_SCALE) + "px"
  : Math.round(12 * BOARD_SCALE) + "px";
numLabel.style.paddingRight = window.innerWidth <= 768
  ? Math.round(0 * BOARD_SCALE) + "px"
  : Math.round(6 * BOARD_SCALE) + "px";
gutter.appendChild(numLabel);

        const strip = document.createElement("div");
        strip.style.height = stripPxH + "px";
        strip.style.width = "100%";
        strip.style.boxShadow = "inset 0 -1px rgba(0,0,0,0.10)";

        const woodName = (s.wood || "").trim();
        const url = WOOD_TEXTURE_URLS[woodName];

        if (url) {
          try {
            if (myRunId !== _updateTotalsRunId) return;
            const safeUrl = url.startsWith("//") ? "https:" + url : url;

            strip.style.backgroundImage = `url('${safeUrl}')`;
            strip.style.backgroundRepeat = "no-repeat";
            strip.style.backgroundPosition = "center";
            strip.style.backgroundSize = "100% 100%";
          } catch (e) {
            strip.style.background = "#ccc";
          }
        } else {
          strip.style.background = "#ccc";
        }

        board.appendChild(strip);
      }

      boardWrap.appendChild(board);

      const rightSpacer = document.createElement("div");
      rightSpacer.style.width = gutterWrapW + "px";
      rightSpacer.style.height = scaledBoardPxH + "px";

      wrapper.appendChild(gutterWrap);
      wrapper.appendChild(boardWrap);
      wrapper.appendChild(rightSpacer);

      if (myRunId !== _updateTotalsRunId) return;

      preview.appendChild(wrapper);
    }
    //============ Section 9b End
  }
  //============ Section 9 End










  /* =========================
     SECTION 10 — Text Overlay (last strip only)
     - Render-only overlay; wizard UI lives inside the strip handlers section.
     - Ensures webfont is loaded before measureText/fillText (Dancing Script fix).
     - Patches updateTotals once to apply overlay after the base preview is built.
     ========================= */

  function cbbGetLastBillableIndex() {
    for (let j = state.strips.length - 1; j >= 0; j--) {
      const woodName = (state.strips[j]?.wood || "").trim();
      if (woodName !== "") return j;
    }
    return -1;
  }

  function cbbIsDarkWoodName(woodName) {
    const w = String(woodName || "").trim().toLowerCase();
    return (
      w === "walnut" ||
      w === "padauk" ||
      w === "purple heart" ||
      w === "goibao"
    );
  }

  // NOTE: This function is legacy from the old checkbox UI.
  // Your current UI uses a button, so this will usually no-op safely.
  function cbbSyncTextToggleUI() {
    const lastBillableIndex = cbbGetLastBillableIndex();
    if (lastBillableIndex < 0) return;

    const wrap = document.getElementById("cb-strips");
    if (!wrap) return;

    const box = wrap.querySelector(`input[type="checkbox"][data-text-toggle="${lastBillableIndex}"]`);
    if (!box) return;

    const lastWidthIn = Number(state.strips[lastBillableIndex]?.width);
    const tooNarrow = Number.isFinite(lastWidthIn) && lastWidthIn < 1;

    if (tooNarrow) {
      if (state.lastStripText) {
        state.lastStripText.enabled = false;
        state.lastStripText.text = "";
        state.lastStripText.lettersCount = 0;
        state.lastStripText.letterHeightIn = 0.5;
      }
      box.checked = false;
      box.disabled = true;
      box.style.opacity = "0.5";
      box.style.cursor = "not-allowed";
      return;
    }

    box.disabled = false;
    box.style.opacity = "";
    box.style.cursor = "";

    const shouldBeChecked = !!state.lastStripText?.enabled;
    if (box.checked !== shouldBeChecked) box.checked = shouldBeChecked;
  }

  function cbbGetBoardScaleFromEl(boardEl) {
    const t = String(boardEl?.style?.transform || "");
    const m = t.match(/scale\(([^)]+)\)/i);
    if (!m) return 1;
    const s = Number(m[1]);
    return Number.isFinite(s) && s > 0 ? s : 1;
  }

  /**
   * Ensure a webfont is loaded BEFORE canvas measureText/fillText.
   * Cached so we don’t re-load every draw.
   */
  function cbbEnsureFontLoaded_Cached(fontKey, weightNumber) {
    const k = String(fontKey || "").toLowerCase();
    const wt = Number(weightNumber);

    // Only gate the webfont we care about here
    if (k !== "dancing") return Promise.resolve(true);

    // Create cache bucket
    window.__cbbFontPromises = window.__cbbFontPromises || {};

    const cacheKey = `${k}-${wt}`;
    if (window.__cbbFontPromises[cacheKey]) return window.__cbbFontPromises[cacheKey];

    // We must load by FAMILY NAME, not the fallback list.
    // Your @font-face uses: font-family: 'Dancing Script';
    const familyForLoad = `"Dancing Script"`;
    const loadStr = `${wt} 32px ${familyForLoad}`;

    const timeoutMs = 2000;

    const p = (async () => {
      try {
        if (!document.fonts || !document.fonts.load) return true;

        // Trigger the load
        await Promise.race([
          document.fonts.load(loadStr),
          new Promise((resolve) => setTimeout(resolve, timeoutMs)),
        ]);

        // Give the browser a moment to commit the font face (safe guard)
        if (document.fonts.ready) {
          await Promise.race([
            document.fonts.ready,
            new Promise((resolve) => setTimeout(resolve, timeoutMs)),
          ]);
        }

        return true;
      } catch (e) {
        // If something goes wrong, don’t crash the builder—just allow fallback.
        return true;
      }
    })();

    window.__cbbFontPromises[cacheKey] = p;
    return p;
  }

  async function cbbApplyTextOverlayToPreview() {
    const cfg = state.lastStripText || {};
    if (!cfg.enabled) return;

    const text = String(cfg.text || "").trim();
    if (!text) return;

    const lastBillableIndex = cbbGetLastBillableIndex();
    if (lastBillableIndex < 0) return;

    const lastWidthIn = Number(state.strips[lastBillableIndex]?.width);
    if (!Number.isFinite(lastWidthIn) || lastWidthIn < 1) {
      cfg.enabled = false;
      cfg.text = "";
      cfg.lettersCount = 0;
      cfg.letterHeightIn = 0.5;
      return;
    }

    const preview = document.getElementById("cb-preview");
    if (!preview) return;

    const board = preview.querySelector('div[style*="transform"][style*="scale("]');
    if (!board) return;

    const strips = board.children;
    if (!strips || strips.length < 1) return;

    const lastStripEl = strips[strips.length - 1];
    if (!lastStripEl) return;

    const existing = lastStripEl.querySelector(".cbb-text-overlay-canvas");
    if (existing) existing.remove();

    const w = Math.max(1, Math.round(lastStripEl.clientWidth));
    const h = Math.max(1, Math.round(lastStripEl.clientHeight));
    if (w <= 1 || h <= 1) return;

    lastStripEl.style.position = "relative";

    // HiDPI + transform-scale compensation:
    const dpr = (window.devicePixelRatio || 1);
    const boardScale = cbbGetBoardScaleFromEl(board);
    const backingScale = Math.max(1, dpr * boardScale);

    const canvas = document.createElement("canvas");
    canvas.className = "cbb-text-overlay-canvas";
    canvas.width = Math.round(w * backingScale);
    canvas.height = Math.round(h * backingScale);
    canvas.style.position = "absolute";
    canvas.style.left = "0";
    canvas.style.top = "0";
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    canvas.style.pointerEvents = "none";

    lastStripEl.appendChild(canvas);

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    // Draw in CSS pixel coordinates, but render at higher backing resolution for sharpness
    ctx.setTransform(backingScale, 0, 0, backingScale, 0, 0);
    ctx.clearRect(0, 0, w, h);

    function cbbFontFromKeyLocal(fontKey) {
      const k = String(fontKey || "arial").toLowerCase();
      if (k === "georgia") return "Georgia, serif";
      if (k === "courier") return `"Courier New", Courier, monospace`;
      if (k === "dancing") return `"Dancing Script", cursive`;
      return "Arial, Helvetica, sans-serif";
    }

    // Must use persisted state values
    const fontKey = String(cfg.fontKey || "arial").toLowerCase();
    const fontFamily = String(cfg.fontFamily || cbbFontFromKeyLocal(cfg.fontKey));

    // ✅ CRITICAL FIX: ensure Dancing Script is loaded BEFORE any measureText/fillText
    if (fontKey === "dancing") {
      await cbbEnsureFontLoaded_Cached("dancing", 700);
    }

    // inches->pixels in the strip-height direction (CSS px)
    const stripPpi = h / lastWidthIn;

    let desiredLetterHeightIn = Number(cfg.letterHeightIn);
    if (!Number.isFinite(desiredLetterHeightIn) || desiredLetterHeightIn <= 0) desiredLetterHeightIn = 0.5;

    const minHIn = 0.5;
    const maxHIn = Math.min(1.0, Math.max(0.5, lastWidthIn - 0.5));
    desiredLetterHeightIn = Math.max(minHIn, Math.min(maxHIn, desiredLetterHeightIn));

    // VCarve-style target outline height in pixels (CSS px):
    const targetOutlineHpx = Math.max(1, desiredLetterHeightIn * stripPpi);

    // Padding: 1/4" from left/right converted using px-per-inch along the board length
    const boardLengthIn = Number(state.boardLength);
    const pxPerInX = (Number.isFinite(boardLengthIn) && boardLengthIn > 0) ? (w / boardLengthIn) : 1;
    const padIn = 0.25;
    const padX = Math.max(0, Math.round(padIn * pxPerInX));
    const maxW = Math.max(1, w - (padX * 2));

    // Compute fontSize so measured OUTLINE height equals targetOutlineHpx
    const baseSize = 100;

    // IMPORTANT: weight handling
    const weight = (fontKey === "dancing") ? 700 : 400;

    ctx.textBaseline = "alphabetic";
    ctx.font = `${weight} ${baseSize}px ${fontFamily}`;

    // FIRST measureText happens here — now the font is loaded (or timed out safely)
    const m0 = ctx.measureText(text);
    const a0 = Number(m0.actualBoundingBoxAscent);
    const d0 = Number(m0.actualBoundingBoxDescent);
    const measuredOutlineH0 = (Number.isFinite(a0) && Number.isFinite(d0) && (a0 + d0) > 0) ? (a0 + d0) : baseSize;

    const scaleH = targetOutlineHpx / Math.max(1, measuredOutlineH0);
    let fontSize = Math.max(1, baseSize * scaleH);

    // Apply that size and measure width
    ctx.font = `${weight} ${fontSize}px ${fontFamily}`;
    let textW = ctx.measureText(text).width;

    // Safety net: prevent obvious overflow if board length changed after wizard selection
    if (textW > maxW + 1e-6) {
      const s = maxW / Math.max(1, textW);
      fontSize = Math.max(1, fontSize * s);
      ctx.font = `${weight} ${fontSize}px ${fontFamily}`;
      textW = ctx.measureText(text).width;
    }

    // Alignment
    const align = String(cfg.align || "center").toLowerCase();
    if (align === "left") ctx.textAlign = "left";
    else if (align === "right") ctx.textAlign = "right";
    else ctx.textAlign = "center";

    let x = Math.round(w / 2);
    if (align === "left") x = padX;
    if (align === "right") x = w - padX;

    // Vertical center using measured ascent/descent at final size
    const mf = ctx.measureText(text);
    const af = Number(mf.actualBoundingBoxAscent);
    const df = Number(mf.actualBoundingBoxDescent);
    const ascent = (Number.isFinite(af) ? af : fontSize * 0.8);
    const descent = (Number.isFinite(df) ? df : fontSize * 0.2);

    // baseline y so that the outline box is centered vertically
    const y = Math.round((h / 2) + ((ascent - descent) / 2));

    // Wood-aware “ink”
    const woodName = String(state.strips[lastBillableIndex]?.wood || "").trim();
    const darkWood = cbbIsDarkWoodName(woodName);

    if (darkWood) {
      canvas.style.mixBlendMode = "screen";
      ctx.fillStyle = "rgba(255,255,255,0.60)";
    } else {
      canvas.style.mixBlendMode = "multiply";
      ctx.fillStyle = "rgba(35,18,10,0.60)";
    }

    // IMPORTANT: remove blur for crisp text
    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;

    ctx.fillText(text, x, y);
  }

  (function cbbPatchUpdateTotalsOnce_TextOverlay() {
    if (window.__cbbUpdateTotalsPatchedTextOverlay === true) return;
    window.__cbbUpdateTotalsPatchedTextOverlay = true;

    const _orig = updateTotals;
    updateTotals = async function patchedUpdateTotals_TextOverlay() {
      await _orig();
      cbbSyncTextToggleUI();
      await cbbApplyTextOverlayToPreview();
    };
  })();

  //============ Section 10 End










/* =========================
   SECTION 11 — Buttons (add to cart + mirror + print states)
   - Central place to enable/disable buttons based on current selections.
   - Mirror and Print buttons are validated separately.
   - Add-to-Cart is kept simple; click behavior is handled elsewhere.
   ========================= */
  const cartBtn = document.getElementById("cb-add-to-cart");

  function updateButtonStates() {
    const billableStrips = state.strips.filter((s) => (s.wood || "").trim() !== "");
    const billableWidth = billableStrips.reduce((a, s) => a + num(s.width, 0), 0);

    // --- Mirror button (needs room to mirror) ---
    const mirrorBtnNow = document.getElementById("cb-mirror");
    if (mirrorBtnNow) {
      const billableCount = billableStrips.length;
      const mirrorAdds = Math.max(0, billableCount - 1);
      const reserveBlank = state.strips.length < MAX_STRIPS ? 1 : 0;
      const availableSlots = MAX_STRIPS - state.strips.length - reserveBlank;

      const canMirror = billableCount >= 2 && availableSlots >= mirrorAdds;
      mirrorBtnNow.disabled = !canMirror && !mirrorState.snapshotStrips;
      mirrorBtnNow.style.opacity = (!canMirror && !mirrorState.snapshotStrips) ? "0.5" : "1";
      mirrorBtnNow.style.cursor = (!canMirror && !mirrorState.snapshotStrips) ? "not-allowed" : "pointer";
    }

    // --- Email Build Sheet button ---
    const printBtnNow = document.getElementById("cb-print");
    if (printBtnNow) {
      const canEmail = billableStrips.length > 0;

      if (canEmail) {
        printBtnNow.style.display = "";
        printBtnNow.disabled = false;
        printBtnNow.style.opacity = "1";
        printBtnNow.style.cursor = "pointer";
      } else {
        printBtnNow.style.display = "none";
      }
    }

    // --- Add to Cart button ---
    if (cartBtn) {
      const canAdd = billableStrips.length > 0 && billableWidth <= TOTAL_WIDTH_MAX + 1e-9;
      cartBtn.disabled = !canAdd;
      cartBtn.style.opacity = canAdd ? "1" : "0.5";
      cartBtn.style.cursor = canAdd ? "pointer" : "not-allowed";
    }
  }

  // IMPORTANT:
  // Add-to-cart click behavior is handled ONLY by SECTION 14 (handle-based cart + packaging).
//============ Section 11 End










/* =========================
   SECTION 11a — Print Build Sheet (browser print / Save as PDF)
   - Prints ONLY strips with wood selected.
   - Mirrors SECTION 9b board proportions using board length vs total width.
   - Prioritizes fitting on ONE portrait page.
   - Removes the extra ghost wrapper look.
   - Aligns the strip table width to the same preview block width.
   - Waits briefly for images before calling window.print().
   - Renders carved text onto the LAST strip in the print window using canvas.
   ========================= */
  const PRINT_LOGO_URL =
    "https://cdn.shopify.com/s/files/1/0710/4544/7974/files/WoodPRO_Logo_Transparent.png?v=1771532282";
  const printBtn = document.getElementById("cb-print");

  function _escapeHtml(s) {
    return String(s ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function openPrintBuildSheet() {
    const billable = state.strips
      .map((s, idx) => ({ s, idx }))
      .filter(({ s }) => (s.wood || "").trim() !== "");

    if (!billable.length) return;

    const boardLengthIn = Math.max(0.01, num(state.boardLength, 16));
    const totalBoardWidthIn = Math.max(
      0.01,
      billable.reduce((a, { s }) => a + num(s.width, 0), 0)
    );

    const lastBillable = billable[billable.length - 1] || null;
    const lastBillableWood = String(lastBillable?.s?.wood || "").trim();
    const lastBillableWidthIn = Math.max(0.01, num(lastBillable?.s?.width, 0));

    const textCfg = state.lastStripText || {};
    const printTextEnabled =
      !!textCfg.enabled && String(textCfg.text || "").trim().length > 0;

    const printTextPayload = JSON.stringify({
      enabled: printTextEnabled,
      text: String(textCfg.text || ""),
      align: String(textCfg.align || "center"),
      fontKey: String(textCfg.fontKey || "arial"),
      fontFamily: String(textCfg.fontFamily || ""),
      letterHeightIn: Number(textCfg.letterHeightIn || 0.5),
      boardLengthIn: Number(boardLengthIn),
      lastStripWidthIn: Number(lastBillableWidthIn),
      lastStripWood: String(lastBillableWood || ""),
    }).replace(/</g, "\\u003c");

    const GUTTER_PX = 36;
    const BOARD_WIDTH_PX = 420; // conservative for one-page fit
    const PREVIEW_WIDTH_PX = GUTTER_PX + BOARD_WIDTH_PX;

    const boardHeightPx = Math.max(
      42,
      Math.round(BOARD_WIDTH_PX * (totalBoardWidthIn / boardLengthIn))
    );

    const rows = billable
      .map(({ s, idx }) => {
        const n = idx + 1;
        const wood = (s.wood || "").trim();
        const width = num(s.width, 0);
        return `
          <tr>
            <td style="padding:6px 8px;border:1px solid #ddd;text-align:center;font-weight:700;width:56px;">#${n}</td>
            <td style="padding:6px 8px;border:1px solid #ddd;">${_escapeHtml(wood)}</td>
            <td style="padding:6px 8px;border:1px solid #ddd;text-align:right;width:90px;">${width.toFixed(2)}"</td>
          </tr>
        `;
      })
      .join("");

    const html = `
<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  <title>woodprodesigns.com</title>

  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@700&display=swap" rel="stylesheet">

  <style>
    @page { margin: 0.45in; }

    html, body {
      margin: 0;
      padding: 0;
      font-family: Arial, Helvetica, sans-serif;
      color: #111;
    }

    body {
      font-size: 12px;
      line-height: 1.25;
    }

    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      margin-bottom: 8px;
    }

    .logo {
      height: 42px;
      width: auto;
    }

    .title {
      font-size: 17px;
      font-weight: 900;
      line-height: 1.1;
      text-align: center;
    }

    .sub {
      margin-top: 1px;
      font-size: 11px;
      color: #444;
      line-height: 1.15;
    }

    .section {
      margin-top: 8px;
    }

    .h2 {
      font-size: 13px;
      font-weight: 900;
      margin-bottom: 4px;
      line-height: 1.1;
      text-align: center;
    }

    /* Single shared width reference for preview + note + table */
    .printBlock {
      width: ${PREVIEW_WIDTH_PX}px;
      margin: 0 auto;
      page-break-inside: avoid;
    }

    /* Remove outer duplicate border layer that created the "ghost" look */
    .boardShell {
      margin-top: 4px;
      display: inline-block;
    }

    .boardGrid {
      display: grid;
      grid-template-columns: ${GUTTER_PX}px ${BOARD_WIDTH_PX}px;
      align-items: stretch;
      width: ${PREVIEW_WIDTH_PX}px;
    }

    .boardOnly {
      width: ${BOARD_WIDTH_PX}px;
      border: 1px solid rgba(0,0,0,0.12);
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 6px 14px rgba(0,0,0,.08);
      background: #f3f3f3;
    }

    .printStrip {
      position: relative;
      line-height: 0;
    }

    .muted {
      color: #555;
      font-size: 10.5px;
      margin-top: 4px;
      line-height: 1.15;
    }

    .tableWrap {
      width: ${PREVIEW_WIDTH_PX}px;
      margin: 0 auto;
      page-break-inside: avoid;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 11.5px;
    }

    .note {
      width: ${PREVIEW_WIDTH_PX}px;
      margin: 8px auto 0 auto;
      padding: 7px 9px;
      border: 1px solid #e2e2e2;
      background: #fafafa;
      border-radius: 8px;
      font-size: 11px;
      line-height: 1.25;
      page-break-inside: avoid;
      box-sizing: border-box;
    }

    img {
      display: block;
    }
  </style>
</head>
<body>
  <div class="header">
    <img class="logo" src="${_escapeHtml(PRINT_LOGO_URL)}" alt="WoodPro Designs" />
    <div>
      <div class="title">WoodPro Designs – Cutting Board Build Sheet</div>
      <div class="sub">Print this page, or choose “Save as PDF” in your print dialog.</div>
    </div>
  </div>

  <div class="section">
    <div class="h2" style="width:${PREVIEW_WIDTH_PX}px;margin:0 auto;text-align:center;">Board Preview (Strip Order)</div>
    <div class="printBlock">
      <div class="boardShell">
        <div class="boardGrid">
          <div></div>
          <div class="boardOnly">
            ${billable.map(({ s, idx }, i) => {
              const wood = (s.wood || "").trim();
              const url = WOOD_TEXTURE_URLS[wood] || "";
              const stripWidthIn = Math.max(0.01, num(s.width, 0));
              const hPx = Math.max(
                1,
                Math.round(boardHeightPx * (stripWidthIn / totalBoardWidthIn))
              );
              const overlap = i === 0 ? 0 : -1;
              const isLast = i === billable.length - 1;
              const stripId = isLast ? ` id="cbb-print-last-strip"` : "";
              const stripData = ` data-strip-width-in="${stripWidthIn}" data-wood-name="${_escapeHtml(wood)}"`;

              if (url) {
                return `<div class="printStrip"${stripId}${stripData} style="height:${hPx}px;line-height:0;margin-top:${overlap}px;">
                  <img src="${_escapeHtml(url)}" alt="${_escapeHtml(wood)}"
                    style="width:100%;height:${hPx}px;object-fit:cover;display:block;" />
                </div>`;
              }

              return `<div class="printStrip"${stripId}${stripData} style="height:${hPx}px;background:#ccc;line-height:0;margin-top:${overlap}px;"></div>`;
            }).join("")}
          </div>
        </div>

        <div style="position:relative; width:${PREVIEW_WIDTH_PX}px; margin-top:${-boardHeightPx}px; pointer-events:none;">
          <div style="display:flex; flex-direction:column; width:${GUTTER_PX}px;">
            ${billable.map(({ s, idx }) => {
              const stripWidthIn = Math.max(0.01, num(s.width, 0));
              const hPx = Math.max(
                1,
                Math.round(boardHeightPx * (stripWidthIn / totalBoardWidthIn))
              );
              return `<div style="height:${hPx}px;display:flex;align-items:center;justify-content:flex-end;padding-right:7px;font-weight:400;color:#555;font-size:12px;box-sizing:border-box;">#${idx + 1}</div>`;
            }).join("")}
          </div>
        </div>
      </div>

      <div class="muted">
        Note: Some printers/browsers require “Print background graphics” enabled for best wood-grain printing.
      </div>
    </div>
  </div>

  <div class="section">

    <div style="margin-top:4px;margin-bottom:12px;font-size:12px;font-weight:700;text-align:center;">
      Board Length: ${boardLengthIn}"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Board Width: ${totalBoardWidthIn.toFixed(2)}"
    </div>

    <div class="h2" style="text-align:center;">Strip List</div>

    <div class="tableWrap">
      <table>
        <thead>
          <tr>
            <th style="padding:6px 8px;border:1px solid #ddd;text-align:center;width:56px;">Strip</th>
            <th style="padding:6px 8px;border:1px solid #ddd;text-align:left;">Wood</th>
            <th style="padding:6px 8px;border:1px solid #ddd;text-align:right;width:90px;">Width</th>
          </tr>
        </thead>
        <tbody>
          ${rows}
        </tbody>
      </table>
    </div>
  </div>

  <div class="note">
    <div style="font-weight:900;margin-bottom:4px;">Glue-up tip</div>
    <div>
      Use this as a guide to ensure you lay strips in order. Take care to align strips carefully, making sure they
      all stay the same height when gluing. Use a food-safe finish. Do not put the cutting board in the dishwasher.
    </div>
  </div>

  <script>
    const CBB_PRINT_TEXT = ${printTextPayload};

    function cbbPrintIsDarkWoodName(woodName) {
      const w = String(woodName || "").trim().toLowerCase();
      return (
        w === "walnut" ||
        w === "padauk" ||
        w === "purple heart" ||
        w === "goibao"
      );
    }

    function cbbPrintFontFromKey(fontKey) {
      const k = String(fontKey || "arial").toLowerCase();
      if (k === "georgia") return "Georgia, serif";
      if (k === "dancing") return '"Dancing Script", cursive';
      return "Arial, Helvetica, sans-serif";
    }

    function cbbPrintEnsureFontLoaded(fontKey, weightNumber) {
      const k = String(fontKey || "").toLowerCase();
      const wt = Number(weightNumber);

      if (k !== "dancing") return Promise.resolve(true);

      window.__cbbPrintFontPromises = window.__cbbPrintFontPromises || {};
      const cacheKey = k + "-" + wt;
      if (window.__cbbPrintFontPromises[cacheKey]) return window.__cbbPrintFontPromises[cacheKey];

      const familyForLoad = '"Dancing Script"';
      const loadStr = wt + " 32px " + familyForLoad;
      const timeoutMs = 2000;

      const p = (async function () {
        try {
          if (!document.fonts || !document.fonts.load) return true;

          await Promise.race([
            document.fonts.load(loadStr),
            new Promise((resolve) => setTimeout(resolve, timeoutMs)),
          ]);

          if (document.fonts.ready) {
            await Promise.race([
              document.fonts.ready,
              new Promise((resolve) => setTimeout(resolve, timeoutMs)),
            ]);
          }

          return true;
        } catch (e) {
          return true;
        }
      })();

      window.__cbbPrintFontPromises[cacheKey] = p;
      return p;
    }

    async function cbbApplyPrintTextOverlay() {
      const cfg = CBB_PRINT_TEXT || {};
      if (!cfg.enabled) return;

      const text = String(cfg.text || "").trim();
      if (!text) return;

      const lastStripEl = document.getElementById("cbb-print-last-strip");
      if (!lastStripEl) return;

      const lastWidthIn = Number(cfg.lastStripWidthIn);
      if (!Number.isFinite(lastWidthIn) || lastWidthIn < 1) return;

      const w = Math.max(1, Math.round(lastStripEl.clientWidth));
      const h = Math.max(1, Math.round(lastStripEl.clientHeight));
      if (w <= 1 || h <= 1) return;

      const dpr = window.devicePixelRatio || 1;
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      canvas.style.position = "absolute";
      canvas.style.left = "0";
      canvas.style.top = "0";
      canvas.style.width = "100%";
      canvas.style.height = "100%";
      canvas.style.pointerEvents = "none";

      lastStripEl.appendChild(canvas);

      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);

      const fontKey = String(cfg.fontKey || "arial").toLowerCase();
      const fontFamily = String(cfg.fontFamily || cbbPrintFontFromKey(fontKey));
      const weight = fontKey === "dancing" ? 700 : 400;

      if (fontKey === "dancing") {
        await cbbPrintEnsureFontLoaded("dancing", 700);
      }

      const stripPpi = h / lastWidthIn;

      let desiredLetterHeightIn = Number(cfg.letterHeightIn);
      if (!Number.isFinite(desiredLetterHeightIn) || desiredLetterHeightIn <= 0) desiredLetterHeightIn = 0.5;

      const minHIn = 0.5;
      const maxHIn = Math.min(1.0, Math.max(0.5, lastWidthIn - 0.5));
      desiredLetterHeightIn = Math.max(minHIn, Math.min(maxHIn, desiredLetterHeightIn));

      const targetOutlineHpx = Math.max(1, desiredLetterHeightIn * stripPpi);

      const boardLengthIn = Number(cfg.boardLengthIn);
      const pxPerInX = (Number.isFinite(boardLengthIn) && boardLengthIn > 0) ? (w / boardLengthIn) : 1;
      const padIn = 0.25;
      const padX = Math.max(0, Math.round(padIn * pxPerInX));
      const maxW = Math.max(1, w - (padX * 2));

      const baseSize = 100;
      ctx.textBaseline = "alphabetic";
      ctx.font = weight + " " + baseSize + "px " + fontFamily;

      const m0 = ctx.measureText(text);
      const a0 = Number(m0.actualBoundingBoxAscent);
      const d0 = Number(m0.actualBoundingBoxDescent);
      const measuredOutlineH0 =
        (Number.isFinite(a0) && Number.isFinite(d0) && (a0 + d0) > 0)
          ? (a0 + d0)
          : baseSize;

      const scaleH = targetOutlineHpx / Math.max(1, measuredOutlineH0);
      let fontSize = Math.max(1, baseSize * scaleH);

      ctx.font = weight + " " + fontSize + "px " + fontFamily;
      let textW = ctx.measureText(text).width;

      if (textW > maxW + 1e-6) {
        const s = maxW / Math.max(1, textW);
        fontSize = Math.max(1, fontSize * s);
        ctx.font = weight + " " + fontSize + "px " + fontFamily;
        textW = ctx.measureText(text).width;
      }

      const align = String(cfg.align || "center").toLowerCase();
      if (align === "left") ctx.textAlign = "left";
      else if (align === "right") ctx.textAlign = "right";
      else ctx.textAlign = "center";

      let x = Math.round(w / 2);
      if (align === "left") x = padX;
      if (align === "right") x = w - padX;

      const mf = ctx.measureText(text);
      const af = Number(mf.actualBoundingBoxAscent);
      const df = Number(mf.actualBoundingBoxDescent);
      const ascent = Number.isFinite(af) ? af : fontSize * 0.8;
      const descent = Number.isFinite(df) ? df : fontSize * 0.2;
      const y = Math.round((h / 2) + ((ascent - descent) / 2));

      const darkWood = cbbPrintIsDarkWoodName(String(cfg.lastStripWood || ""));
      if (darkWood) {
        ctx.fillStyle = "rgba(255,255,255,0.60)";
      } else {
        ctx.fillStyle = "rgba(35,18,10,0.60)";
      }

      ctx.shadowBlur = 0;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;

      ctx.fillText(text, x, y);
    }

    (function() {
      function allImagesLoaded() {
        var imgs = Array.prototype.slice.call(document.images || []);
        if (!imgs.length) return true;
        return imgs.every(function(img) { return img.complete && img.naturalWidth > 0; });
      }

      function doPrint() {
        setTimeout(function(){ window.print(); }, 100);
      }

      window.addEventListener("load", async function() {
        var start = Date.now();
        var maxWaitMs = 2500;

        (function waitLoop() {
          if (allImagesLoaded()) {
            Promise.resolve(cbbApplyPrintTextOverlay()).finally(doPrint);
            return;
          }
          if (Date.now() - start > maxWaitMs) {
            Promise.resolve(cbbApplyPrintTextOverlay()).finally(doPrint);
            return;
          }
          setTimeout(waitLoop, 60);
        })();
      });
    })();
  </script>
</body>
</html>
    `;

    const w = window.open("", "_blank");
    if (!w) {
      alert("Your browser blocked the print window. Please allow popups for this site, then try again.");
      return;
    }
    w.document.open();
    w.document.write(html);
    w.document.close();
  }

  if (printBtn) {
    printBtn.addEventListener("click", () => {
      openPrintBuildSheet();
    });
  }
  //============ Section 11a End










  /* =========================
     SECTION 11b — Start Over (browser confirm + reset)
     - Resets builder to default length/thickness/one blank strip.
     - Clears mirror undo and removes persisted localStorage state.
     - Re-renders and refreshes totals so UI stays consistent.
     ========================= */
  const startOverBtn = document.getElementById("cb-start-over");

  function resetBuilder() {
    state.boardLength = 16;
    state.thickness = 0.75;
    state.strips = [{ width: 1.0, wood: "" }];

    clearMirrorUndo();
    localStorage.removeItem(STORAGE_KEY);

    const lengthSelNow = document.getElementById("cb-length");
    const thickSelNow = document.getElementById("cb-thickness");
    if (lengthSelNow) lengthSelNow.value = "16";
    if (thickSelNow) thickSelNow.value = "0.75";

    renderStrips();
    bindStripHandlers();
    updateTotals();
    updateButtonStates();
  }

  if (startOverBtn) {
    startOverBtn.addEventListener("click", () => {
      const ok = window.confirm(
        "Start over?\n\nThis will clear all strips and reset length to 16\"."
      );
      if (!ok) return;
      resetBuilder();
    });
  }
  //============ Section 11b End










  /* =========================
     SECTION 11c — Mirror Image (toggle: Mirror Image ↔ Undo Mirror)
     - Mirrors all strips except the center strip (classic symmetry).
     - Uses snapshotStrips for a reliable "Undo Mirror".
     - Enforces MAX_STRIPS capacity and preserves one trailing blank row.
     ========================= */
  const mirrorBtn = document.getElementById("cb-mirror");

  function doMirror() {
    const billable = state.strips.filter((s) => (s.wood || "").trim() !== "");

    if (billable.length < 2) {
      alert("Add at least 2 strips (with wood selected) before using Mirror Image.");
      return;
    }

    mirrorState.snapshotStrips = cloneStrips(state.strips);
    setMirrorButtonLabel();

    while (
      state.strips.length > 0 &&
      (state.strips[state.strips.length - 1].wood || "").trim() === ""
    ) {
      state.strips.pop();
    }

    const billableNow = state.strips.filter((s) => (s.wood || "").trim() !== "");
    if (billableNow.length < 2) {
      alert("Add at least 2 strips (with wood selected) before using Mirror Image.");
      state.strips = cloneStrips(mirrorState.snapshotStrips);
      mirrorState.snapshotStrips = null;
      setMirrorButtonLabel();
      renderStrips();
      bindStripHandlers();
      updateTotals();
      return;
    }

    const toMirror = billableNow
      .slice(0, -1)
      .reverse()
      .map((s) => ({
        width: Number(s.width),
        wood: (s.wood || "").trim(),
      }));

    const reserveBlank = state.strips.length < MAX_STRIPS ? 1 : 0;
    const availableForMirror = Math.max(0, MAX_STRIPS - state.strips.length - reserveBlank);

    const addCount = Math.min(toMirror.length, availableForMirror);
    if (addCount <= 0) {
      alert("No room left to mirror (max 21 strips).");

      state.strips = cloneStrips(mirrorState.snapshotStrips);
      mirrorState.snapshotStrips = null;
      setMirrorButtonLabel();

      renderStrips();
      bindStripHandlers();
      updateTotals();
      return;
    }

    for (let i = 0; i < addCount; i++) {
      state.strips.push(toMirror[i]);
    }

    if (state.strips.length < MAX_STRIPS) {
      state.strips.push({ width: STRIP_MIN, wood: "" });
    }

    renderStrips();
    bindStripHandlers();
    updateTotals();
  }

  function undoMirror() {
    if (!mirrorState.snapshotStrips) return;

    state.strips = cloneStrips(mirrorState.snapshotStrips);
    mirrorState.snapshotStrips = null;
    setMirrorButtonLabel();

    renderStrips();
    bindStripHandlers();
    updateTotals();
  }

  if (mirrorBtn) {
    setMirrorButtonLabel();

    mirrorBtn.addEventListener("click", () => {
      if (mirrorState.snapshotStrips) {
        undoMirror();
      } else {
        doMirror();
      }
    });
  }
  //============ Section 11c End










  /* =========================
     SECTION 12 — Initial render
     - Loads persisted state (if present) into runtime state.
     - Wires board length changes to rerender totals and preview.
     - Performs first render + bind + totals update on page load.
     ========================= */
  loadState({
    stripMin: STRIP_MIN,
    stripMax: STRIP_MAX,
    maxStrips: MAX_STRIPS,
  });

  const lengthSelNow = document.getElementById("cb-length");
  const thickSelNow = document.getElementById("cb-thickness");

  if (lengthSelNow) {
    const v = String(state.boardLength);
    if ([...lengthSelNow.options].some((o) => o.value === v)) lengthSelNow.value = v;

    // ✅ FIX: when user changes board length dropdown, update state + rerender
    lengthSelNow.addEventListener("change", () => {
      clearMirrorUndo();
      state.boardLength = Number(lengthSelNow.value || 16);
      updateTotals();
      updateButtonStates();
    });
  }

  if (thickSelNow) {
    const v = String(state.thickness);
    if ([...thickSelNow.options].some((o) => o.value === v)) thickSelNow.value = v;
  }

  renderStrips();
  bindStripHandlers();
  updateTotals();
  updateButtonStates();
  cbbWireButtonHovers();
  
  // Force one extra async pricing pass after restored state finishes rendering
  setTimeout(() => {
    updateTotals();
  }, 0);
  /* cbbWireAddToCartButton wired in Section 2 */
  //============ Section 12 End
}



 //============ Section 1 End










/* =========================
   SECTION 13 — Shopify section lifecycle (retry until mount exists)
   - Retries builder init until mount exists (Shopify sections may load late).
   - Resets initialized flag on section unload for safe re-entry.
   - Re-inits on section load (theme editor + dynamic section changes).
   ========================= */
(function bootBuilder() {
  let tries = 0;
  const maxTries = 80; // ~8 seconds at 100ms

  function tryLoad() {
    const el = document.getElementById("cutting-board-builder");
    if (el) {
      if (el.dataset.cbbInitialized === "1") return;

      loadBuilder();
      return;
    }

    tries++;
    if (tries < maxTries) {
      setTimeout(tryLoad, 100);
    } else {
      console.warn("Builder mount not found after retries.");
    }
  }

  tryLoad();
})();

document.addEventListener("shopify:section:unload", () => {
  const el = document.getElementById("cutting-board-builder");
  if (!el) return;
  el.dataset.cbbInitialized = "0";
});

document.addEventListener("shopify:section:load", () => {
  const el = document.getElementById("cutting-board-builder");
  if (!el) return;

  if (el.dataset.cbbInitialized === "1") return;

  setTimeout(loadBuilder, 50);
});
//============ Section 13 End










/* =========================
   SECTION 14 — Cart + Checkout Integration
   - Loads strip/product variants by handle (cached).
   - Loads packaging product by handle (cached).
   - Adds strip items, then forces exactly one Packaging line.
   - Optionally forces exactly one Text add-on line with clean properties.
   ========================= */

let CBB_VARIANTS_CACHE = null;
let CBB_PACK_PRODUCT_CACHE = null;
let CBB_TEXT_PRODUCT_CACHE = null;

function cbbCleanOptionValue(v) {
  return String(v ?? "")
    .replace(/"/g, "")
    .trim();
}

function cbbNormalizeNumberString(v) {
  const n = Number(cbbCleanOptionValue(v));
  if (!Number.isFinite(n)) return cbbCleanOptionValue(v);
  return String(n);
}

async function cbbLoadVariantsByHandle(handle) {
  if (CBB_VARIANTS_CACHE) return CBB_VARIANTS_CACHE;

  const url = `/products/${handle}.js`;
  const res = await fetch(url, { credentials: "same-origin" });
  if (!res.ok) {
    throw new Error(`Failed to load product JSON: ${url} (${res.status})`);
  }

  const product = await res.json();

  const map = new Map();
  (product.variants || []).forEach((v) => {
    const wood = cbbCleanOptionValue(v.option1);
    const length = cbbNormalizeNumberString(v.option2);
    const width = cbbNormalizeNumberString(v.option3);

    const key = `${wood}|${length}|${width}`;
    map.set(key, v.id);
  });

  CBB_VARIANTS_CACHE = map;
  return map;
}

async function cbbLoadPackProductByHandle(handle) {
  if (CBB_PACK_PRODUCT_CACHE && CBB_PACK_PRODUCT_CACHE.handle === handle) return CBB_PACK_PRODUCT_CACHE;

  const url = `/products/${handle}.js`;
  const res = await fetch(url, { credentials: "same-origin" });
  if (!res.ok) {
    throw new Error(`Failed to load packaging product JSON: ${url} (${res.status})`);
  }

  const product = await res.json();

  CBB_PACK_PRODUCT_CACHE = {
    handle,
    productId: product?.id,
    firstVariantId: product?.variants?.[0]?.id,
    variants: product?.variants || [],
  };

  return CBB_PACK_PRODUCT_CACHE;
}

async function cbbLoadTextProductByHandle(handle) {
  if (CBB_TEXT_PRODUCT_CACHE && CBB_TEXT_PRODUCT_CACHE.handle === handle) return CBB_TEXT_PRODUCT_CACHE;

  const url = `/products/${handle}.js`;
  const res = await fetch(url, { credentials: "same-origin" });
  if (!res.ok) {
    throw new Error(`Failed to load text add-on product JSON: ${url} (${res.status})`);
  }

  const product = await res.json();

  // Flat-fee text add-on: we will use the FIRST variant
  const firstVariantId = product?.variants?.[0]?.id;

  CBB_TEXT_PRODUCT_CACHE = {
    handle,
    productId: product?.id,
    firstVariantId: firstVariantId,
    variants: product?.variants || [],
  };

  return CBB_TEXT_PRODUCT_CACHE;
}

function cbbGetHandlesFromMount() {
  const el = document.getElementById("cutting-board-builder");
  if (!el) return { stripHandle: "", packHandle: "", textHandle: "" };

  return {
    stripHandle: (el.dataset.stripHandle || "").trim(),
    packHandle: (el.dataset.packHandle || "").trim(),
    textHandle: (el.dataset.textHandle || "").trim(),
  };
}

function cbbGetStateFromMount() {
  const el = document.getElementById("cutting-board-builder");
  if (!el) return null;
  return el._cbbState || null;
}

function cbbGetCurrentStripsFromState() {
  const st = cbbGetStateFromMount();
  if (!st) return [];

  const length = cbbNormalizeNumberString(st.boardLength);

  return (st.strips || [])
    .filter((s) => (s.wood || "").trim() !== "")
    .map((s) => ({
      wood: cbbCleanOptionValue(s.wood),
      length,
      width: cbbNormalizeNumberString(s.width),
    }))
    .filter((s) => s.wood && s.length && s.width);
}

function cbbGroupStripsToCounts(strips) {
  const counts = new Map();
  strips.forEach((s) => {
    const key = `${s.wood}|${s.length}|${s.width}`;
    counts.set(key, (counts.get(key) || 0) + 1);
  });
  return counts;
}

function cbbLettersOnlyCount(s) {
  const m = String(s || "").match(/[A-Za-z]/g);
  return m ? m.length : 0;
}



/* =========================
   SECTION 14a — Cart helpers (force Packaging to be exactly ONE line, qty=1)
   - Reads cart state via /cart.js.
   - Changes line items by key using /cart/change.js.
   - Adds items via /cart/add.js with JSON payloads.
   ========================= */
async function cbbGetCart() {
  const res = await fetch("/cart.js", {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!res.ok) throw new Error(`Failed to read cart (/cart.js) (${res.status})`);
  return await res.json();
}

async function cbbChangeCartByKey(lineItemKey, quantity) {
  const res = await fetch("/cart/change.js", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ id: lineItemKey, quantity }),
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`Cart change failed (${res.status}): ${txt}`);
  }
  return await res.json();
}

async function cbbAddItems(items) {
  const res = await fetch("/cart/add.js", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ items }),
  });

  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`Cart add failed (${res.status}): ${txt}`);
  }

  return await res.json();
}

async function cbbForceSinglePackLine(packVariantId) {
  const cart = await cbbGetCart();
  const items = cart?.items || [];

  const packKeys = items
    .filter((it) => Number(it?.variant_id) === Number(packVariantId))
    .map((it) => it.key)
    .filter(Boolean);

  for (const key of packKeys) {
    await cbbChangeCartByKey(key, 0);
  }

  // IMPORTANT: no properties on Packaging line
await cbbAddItems([
  {
    id: packVariantId,
    quantity: 1,
    properties: {
      cbb_lock: "true"
    }
  },
]);
}

async function cbbForceSingleTextLine(textProductId, desiredVariantId, properties) {
  const cart = await cbbGetCart();
  const items = cart?.items || [];

  const textKeys = items
    .filter((it) => Number(it?.product_id) === Number(textProductId))
    .map((it) => it.key)
    .filter(Boolean);

  for (const key of textKeys) {
    await cbbChangeCartByKey(key, 0);
  }

  await cbbAddItems([
    {
      id: desiredVariantId,
      quantity: 1,
      properties: properties || {},
    },
  ]);
}
//============ Section 14a End










/* =========================
   SECTION 14b — Add to cart orchestration
   - Builds strip line items from current state and variant map.
   - REPLACES any existing CBB strip lines (so re-running does NOT double strips).
   - Adds strips + Packaging in ONE single /cart/add.js call.
   - Optionally forces exactly one Text add-on line with clean properties.
   - Redirects user to /cart when done.
   ========================= */
async function cbbAddToCartAndGoToCart() {
  const { stripHandle, packHandle, textHandle } = cbbGetHandlesFromMount();

  if (!stripHandle) {
    alert("Missing strip handle on the builder mount div (data-strip-handle).");
    return;
  }
  if (!packHandle) {
    alert("Missing processing/packaging handle on the builder mount div (data-pack-handle).");
    return;
  }

  const st = cbbGetStateFromMount();
  if (!st) {
    alert("Builder state not found. Refresh the page.");
    return;
  }

  function cbbSleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const CBB_CART_DELAY_MS = 100;

  async function cbbRemoveExistingCbbStripLines() {
    const cart = await cbbGetCart();
    const items = cart?.items || [];

    const keysToRemove = items
      .filter((it) => {
        const props = it?.properties || {};
        return String(props?.cbb_role || "").toLowerCase() === "strip";
      })
      .map((it) => it.key)
      .filter(Boolean);

    for (const key of keysToRemove) {
      await cbbChangeCartByKey(key, 0);
      await cbbSleep(CBB_CART_DELAY_MS);
    }
  }

  const stripMap = await cbbLoadVariantsByHandle(stripHandle);

  const strips = cbbGetCurrentStripsFromState();
  const grouped = cbbGroupStripsToCounts(strips);

  if (grouped.size === 0) {
    alert("Select at least one strip wood species before adding to cart.");
    return;
  }

  const textCfg = st.lastStripText || {};
  const textEnabled = !!textCfg.enabled;
  const textVal = String(textCfg.text || "").trim();
  const letters = cbbLettersOnlyCount(textVal);
  const wantsTextCharge = textEnabled && textVal && letters > 0;

  const itemsToAdd = [];
  const missing = [];

  grouped.forEach((qty, key) => {
    const variantId = stripMap.get(key);
    if (!variantId) {
      missing.push(key.replaceAll("|", " / "));
      return;
    }

    itemsToAdd.push({
      id: variantId,
      quantity: qty,
      properties: {
        cbb_role: "strip",
      },
    });
  });

  if (missing.length) {
    alert(
      "These strips do not have a matching Shopify variant yet:\n\n" +
        missing.join("\n") +
        "\n\nFix by creating those variants in Shopify (Option order: Wood / Length / Width)."
    );
    return;
  }

  const packProduct = await cbbLoadPackProductByHandle(packHandle);
  const packVariantId = packProduct?.firstVariantId;
  if (!packVariantId) {
    throw new Error("Processing & Packaging product must have exactly 1 variant priced $5.");
  }

  const cartBefore = await cbbGetCart();
  const existingItems = cartBefore?.items || [];

  const existingPackKeys = existingItems
    .filter((it) => Number(it?.variant_id) === Number(packVariantId))
    .map((it) => it.key)
    .filter(Boolean);

  for (const key of existingPackKeys) {
    await cbbChangeCartByKey(key, 0);
    await cbbSleep(CBB_CART_DELAY_MS);
  }

  itemsToAdd.push({
    id: packVariantId,
    quantity: 1,
    properties: {
      cbb_lock: "true",
    },
  });

  await cbbRemoveExistingCbbStripLines();
  await cbbSleep(CBB_CART_DELAY_MS);

  await cbbAddItems(itemsToAdd);
  await cbbSleep(CBB_CART_DELAY_MS);

  if (wantsTextCharge) {
    if (!textHandle) {
      throw new Error("Text is enabled, but missing data-text-handle on the builder mount div.");
    }

    const textProduct = await cbbLoadTextProductByHandle(textHandle);
    const desiredVariantId = textProduct.firstVariantId;

    if (!desiredVariantId) {
      throw new Error("Text add-on product must have at least 1 variant (flat fee).");
    }

    await cbbForceSingleTextLine(textProduct.productId, desiredVariantId, {
      Word: textVal,
      "Letter Count": String(letters),
      Alignment: String(textCfg.align || "center"),
      Font: String(textCfg.fontKey || "arial"),
      Height: String(textCfg.letterHeightIn || 0.5),
    });

    await cbbSleep(CBB_CART_DELAY_MS);
  }

  window.location.href = "/cart";
}
//============ Section 14b End










/* =========================
   SECTION 14c — Wire Add-to-Cart Button
   - Ensures the click handler is bound only once per page lifecycle.
   - Calls add-to-cart orchestration and shows a clean error on failure.
   - Must be called after UI injection so the button exists.
   ========================= */
function cbbWireAddToCartButton() {
  const btn = document.getElementById("cb-add-to-cart");
  if (!btn) return;

  if (btn.dataset.cbbCartWired === "1") return;
  btn.dataset.cbbCartWired = "1";

  btn.addEventListener("click", () => {

  // 🔒 Lock button immediately
  btn.disabled = true;
  btn.textContent = "ADDING...";
  btn.style.opacity = "0.6";
  btn.style.cursor = "not-allowed";

  cbbAddToCartAndGoToCart().catch((err) => {
    console.error(err);
    alert(err.message || "Add to cart failed.");

    // 🔓 Re-enable ONLY if something failed
    btn.disabled = false;
    btn.textContent = "ADD TO CART";
    btn.style.opacity = "1";
    btn.style.cursor = "pointer";
  });
});
}
//============ Section 14c End




//============ Section 14 End
